<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <div class="d-none">
        <qr-code-make
          ref="qrCanvas"
          v-model="qrDesign"
          :file.sync="qrSvgDataUrl"
          :link="info?.link"
          @save="autoSave"
        />
      </div>
      <div class="pa-2" style="min-height: 900px; height: 100%">
        <div class="mt-8 mx-8">
          <v-form ref="form" v-model="valid">
            <v-row
              style="justify-content: start; align-items: center"
              class="mx-5"
            >
              <v-col class="py-0 px-4" cols="12" md="6">
                <v-text-field
                  v-model="name"
                  class="rounded-lg"
                  clear-icon="mdi-close-circle-outline"
                  clearable
                  dense
                  label="نام مجموعه"
                  outlined
                  placeholder="مثال: شرکت فناوری پیشرو"
                  :prepend-icon="null"
                  prepend-inner-icon="mdi-factory"
                  :rules="[
                    (v) =>
                      !v ||
                      (v && v.length >= 2) ||
                      'حداقل دو کاراکتر باید وارد شود!',
                    (v) =>
                      (v && v.length <= 100) || 'حداکثر ۱۰۰ کاراکتر مجاز است',
                  ]"
                />
              </v-col>
              <v-col class="py-0 px-4" cols="12" md="6">
                <v-text-field
                  v-model="labelName"
                  class="rounded-lg"
                  clear-icon="mdi-close-circle-outline"
                  clearable
                  dense
                  label="نام محصول"
                  placeholder="صفحه کیبودرد x300z-meta"
                  outlined
                  :rules="rules"
                />
              </v-col>
            </v-row>
            <v-alert
              v-if="showFileInputAlert"
              type="warning"
              color="info lighten-9"
              border="left"
              elevation="2"
              icon="mdi-alert-circle"
              class="ma-4 rounded-lg"
            >
              <strong>هشدار:</strong> لطفاً از ارسال عکس محصول با پس‌زمینه شلوغ
              یا کیفیت پایین خودداری کنید. تصویر باید واضح و با پس‌زمینه ساده
              باشد تا فرایند ساخت کیوآر به‌درستی انجام شود.
            </v-alert>
            <v-row
              style="justify-content: start; align-items: center"
              class="mx-5"
            >
              <v-col class="py-0 px-4" cols="12" md="6">
                <div class="rowinfo">
                  <v-file-input
                    v-model="files.screenshot"
                    :loading="screenshotLoading"
                    accept="image/png, image/jpg, image/jpeg"
                    dense
                    label="انتخاب تصویر فروشگاه/محصول"
                    outlined
                    show-size
                    clearable
                    :rules="[
                      (v) =>
                        (v && v.size < 2000000) ||
                        'حجم فایل باید کمتر از ۲ مگابایت باشد',
                      (v) =>
                        (v && ['image/jpeg', 'image/png'].includes(v.type)) ||
                        'فقط فرمت‌های JPG و PNG مجاز هستند',
                    ]"
                    ref="fileInputproduct"
                    :prepend-icon="null"
                    prepend-inner-icon="mdi-image"
                    @change="readerRead($event, 'screenshot')"
                    @click:prepend-inner="openFileDialog"
                    class="rounded-lg"
                  />
                </div>
                <div
                  v-if="files.screenshot"
                  class="d-flex align-start flex-wrap"
                  style="gap: 8px"
                >
                  <div>
                    <h3>عکس Wide</h3>
                    <canvas
                      id="screenshotWide"
                      style="max-width: 200px; max-height: 150px"
                    ></canvas>
                  </div>
                  <div>
                    <h3>عکس</h3>
                    <canvas
                      id="screenshot600"
                      style="max-width: 200px; max-height: 150px"
                    ></canvas>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-form>
          <!-- Advanced Settings Button -->
          <v-row class="mx-5 mt-4">
            <v-col cols="12" class="text-center">
              <v-btn
                @click="showAdvancedSettings = !showAdvancedSettings"
                color="primary"
                outlined
                class="advanced-settings-btn"
                elevation="2"
              >
                <v-icon class="ml-2">{{
                  showAdvancedSettings ? "mdi-chevron-up" : "mdi-chevron-down"
                }}</v-icon>
                <v-icon class="mr-2">mdi-tune-vertical</v-icon>
                تنظیمات پیشرفته
              </v-btn>
            </v-col>
          </v-row>

          <!-- Advanced Settings Section -->
          <v-expand-transition>
            <div v-show="showAdvancedSettings" class="mx-5">
              <v-card class="pa-4 mt-4" outlined>
                <v-row class="mx-2 mb-4">
                  <v-col class="py-0 pr-0 pl-4" cols="12" md="6">
                    <v-text-field
                      v-model="latinName"
                      class="rounded-lg"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      dense
                      :prepend-icon="null"
                      prepend-inner-icon="mdi-web"
                      label="نام لاتین (آدرس کیوآرکد)"
                      placeholder="مثال: advanced-tech"
                      outlined
                      :rules="[
                        (v) =>
                          !v ||
                          (v && v.length >= 2) ||
                          'حداقل دو کاراکتر باید وارد شود!',
                        (v) =>
                          !v ||
                          /^[a-zA-Z0-9\-_]+$/.test(v) ||
                          'فقط حروف انگلیسی، اعداد و خط تیره مجاز است',
                        (v) =>
                          (v && v.length <= 50) || 'حداکثر ۵۰ کاراکتر مجاز است',
                      ]"
                      hint="نام لاتین در ادامه دامنه قرار می‌گیرد"
                      persistent-hint
                    />
                  </v-col>
                  <v-col class="pa-2 pt-0 l-0 pr-4" cols="12" md="6">
                    <div class="rowinfo">
                      <v-file-input
                        v-model="files.icon"
                        :loading="logoLoading"
                        accept="image/png, image/jpg, image/jpeg"
                        dense
                        label="انتخاب لوگو"
                        class="contentinfo rounded-lg"
                        outlined
                        show-size
                        :rules="[
                          (v) =>
                            (v && v.size < 2000000) ||
                            'حجم فایل باید کمتر از ۲ مگابایت باشد',
                          (v) =>
                            (v &&
                              ['image/jpeg', 'image/png'].includes(v.type)) ||
                            'فقط فرمت‌های JPG و PNG مجاز هستند',
                        ]"
                        ref="fileInputLogo"
                        :prepend-icon="null"
                        prepend-inner-icon="mdi-image"
                        @change="readerRead($event, 'logo')"
                        @click:prepend-inner="openFileDialog"
                      />
                    </div>
                    <div
                      v-if="files.icon"
                      class="d-flex align-start"
                      style="gap: 8px"
                    >
                      <div>
                        <h3>لوگو ۱۴۴px</h3>
                        <canvas
                          id="canvas144"
                          style="max-width: 144px; max-height: 144px"
                        ></canvas>
                      </div>
                      <div>
                        <h3>لوگو ۴۸px</h3>
                        <canvas
                          id="canvas48"
                          style="max-width: 48px; max-height: 48px"
                        ></canvas>
                      </div>
                    </div>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col class="py-0 px-4" cols="12" md="6">
                    <!-- انتخاب رنگ -->
                    <div class="mt-4">
                      <h5 class="mb-3">
                        <v-icon>mdi-palette</v-icon>انتخاب رنگ بندی لیبل محصول
                      </h5>
                      <color-picker-popup
                        v-model="colorPalette"
                        header-label="هدر"
                        body-label="بدنه"
                        text-label="متن"
                        @input="updateColorPalette"
                      />
                    </div>
                  </v-col>

                  <!-- افزودن اطلاعات مجموعه -->

                  <v-col class="py-0 px-4" cols="12" md="6">
                    <v-switch
                      style="padding-top: 30px !important"
                      v-model="oldDataQr"
                      label=" افزودن اطلاعات مجموعه"
                      hide-details
                      dense
                      class="py-0 ma-0"
                      prepend-icon="mdi-folder-information"
                    ></v-switch>
                    <v-radio-group v-model="radioGroup" v-if="oldDataQr">
                      <v-radio
                        label="از کیوآرهای قبلی "
                        value="mylastQr"
                      ></v-radio>
                      <v-radio label="از سایت" value="flagUrl"></v-radio>
                      <v-row v-if="radioGroup === 'mylastQr'">
                        <v-col cols="10">
                          <v-autocomplete
                            v-model="selectedQr"
                            :items="QrData"
                            :loading="qrselectloading"
                            item-text="text"
                            item-value="value"
                            label=" کیوار من"
                            outlined
                            hint="انتخاب کیوآر اختیاری است. در صورت تمایل به استفاده از اطلاعات کاربری کیوآر قبلی"
                            return-object
                            dense
                            :search-input.sync="search"
                            @change="handleSelection"
                            :no-data-text="
                              QrData.length === 0 && !qrselectloading
                                ? 'هیچ کیوآر کدی تا حالا نساخته‌اید'
                                : 'در حال بارگذاری...'
                            "
                          >
                            <template v-slot:item="{ item }">
                              <div class="d-flex row gap-3">
                                <v-list-item-content>
                                  <v-list-item-title>{{
                                    item.text
                                  }}</v-list-item-title>
                                </v-list-item-content>
                              </div>
                            </template>
                            <template v-slot:selection="{ item }">
                              {{ item.name }}
                            </template>
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="2" class="icon">
                          <v-img
                            src="/media/img/logo.webp"
                            lazy-src="/media/img/logo.webp"
                            class="mt-0"
                            width="40"
                            height="40"
                        /></v-col>
                      </v-row>
                      <v-row v-if="radioGroup === 'flagUrl'">
                        <v-col cols="10">
                          <v-text-field
                            v-model="url_"
                            dense
                            :error-messages="errorurl"
                            :rules="urlRules"
                            outlined
                            :placeholder="hinturl"
                            clearable
                            v-bind="$attrs"
                            clear-icon="mdi-close-circle-outline"
                            style="direction: ltr"
                            direction="ltr"
                            label="آدرس سایت"
                          >
                          </v-text-field
                        ></v-col>
                        <v-col cols="2" class="icon2">
                          <svg-base
                            class="mt-0"
                            view-box="0 0 60 60"
                            width="50"
                            height="50"
                          >
                            <svg-location class="mt-0" /> </svg-base
                        ></v-col>
                      </v-row>
                    </v-radio-group>
                  </v-col>
                </v-row>
              </v-card>
            </div>
          </v-expand-transition>

          <!-- Create Button -->
          <v-row class="mx-5 mt-4">
            <v-col cols="12" class="text-left">
              <v-btn
                :loading="loading"
                :disabled="!name || !labelName"
                class="float-end submit-btn"
                elevation="3"
                @click="generatorTextAi()"
              >
                <v-icon class="mr-2">mdi-magic-staff</v-icon>
                ساخت هوشمند لیبل محصول
              </v-btn>
            </v-col>
          </v-row>

          <!-- Building List Section -->
          <v-row class="mx-2 mt-3">
            <v-col cols="12">
              <v-card outlined>
                <v-card-title
                  class="d-flex justify-space-between align-center building-list-header"
                >
                  <div class="d-flex align-center">
                    <v-icon class="mr-2" color="primary">
                      mdi-clock-outline
                    </v-icon>
                    <span class="building-list-title">لیست در حال ساخت‌ها</span>
                  </div>
                  <v-btn
                    icon
                    small
                    color="primary"
                    @click="refreshBuildingList"
                    :loading="refreshingBuildingList"
                    class="refresh-btn"
                  >
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                </v-card-title>

                <v-card-text v-if="buildingList.length > 0">
                  <div class="notification-banner mb-4">
                    <v-alert
                      type="info"
                      border="left"
                      colored-border
                      elevation="2"
                      class="notification-alert"
                    >
                      <div class="d-flex align-center">
                        <!-- <v-icon class="mr-3" color="info">
                              mdi-information-outline
                            </v-icon> -->
                        <div class="notification-content">
                          <div class="notification-title">
                            کیوآر کد شما پس از تکمیل مراحل ساخت، به
                            <router-link
                              to="/qr/list"
                              class="notification-link"
                            >
                              <span class="font-weight-bold"
                                >لیست کیوآرهای من</span
                              >
                            </router-link>
                            منتقل خواهد شد.
                          </div>
                          <div class="notification-subtitle">
                            می‌توانید وضعیت ساخت کیوآر کدهای خود را در اینجا
                            مشاهده کنید
                          </div>
                        </div>
                      </div>
                    </v-alert>
                  </div>
                  <v-list>
                    <v-list-item
                      v-for="(item, index) in buildingList"
                      :key="index"
                      class="mb-3 building-list-item"
                    >
                      <progress_createauto2
                        :info="item"
                        @refreshBuildingList="refreshBuildingList"
                      />
                    </v-list-item>
                  </v-list>
                  <!-- <v-list>
                        <v-list-item
                          v-for="(item, index) in buildingList"
                          :key="index"
                          class="mb-3 building-list-item"
                        >
                          <v-list-item-avatar class="mr-3">
                            <v-icon
                              :color="getStatusColor(item.data.data.auto_build)"
                              size="24"
                            >
                              {{ getStatusIcon(item.data.data.auto_build) }}
                            </v-icon>
                          </v-list-item-avatar>

                          <v-list-item-content>
                            <v-list-item-title class="font-weight-bold mb-1">
                              {{ item.title || "لیبل محصول" }}
                            </v-list-item-title>
                            <v-list-item-subtitle class="mb-2">
                              <v-chip
                                small
                                :color="
                                  getStatusColor(item.data.data.auto_build)
                                "
                                text-color="white"
                                class="mr-2"
                              >
                                {{ getStatusText(item.data.data.auto_build) }}
                              </v-chip>
                              <span class="text-caption grey--text">
                                {{ item.qrType || "لیبل محصول" }}
                              </span>
                            </v-list-item-subtitle>
                            <v-list-item-subtitle class="text-caption">
                              <v-icon small class="mr-1">mdi-link</v-icon>
                              <span class="font-family-monospace">{{
                                `qrland.in/${item.identifier}` || item.qr
                              }}</span>
                            </v-list-item-subtitle>

                            <v-divider v-if="isMobile" />
                            <v-spacer v-else />
                            <div
                              style="width: 100%"
                              v-if="
                                !!item?.data?.data?.auto_id &&
                                item?.data?.data?.auto_id !== null
                              "
                            >
                              <progress_createauto :info="item" />
                            </div>
                          </v-list-item-content>

                          <v-list-item-action class="ml-0">
                            <v-progress-circular
                              v-if="item.data.data.auto_build === 'process'"
                              :value="item.progress || 0"
                              size="40"
                              :color="getProgressColor(item.progress)"
                              width="4"
                            >
                              <span class="text-caption font-weight-bold">
                                {{ Math.round(item.progress || 0) }}%
                              </span>
                            </v-progress-circular>
                            <v-btn
                              v-else-if="
                                item.data.data.auto_build === 'success'
                              "
                              icon
                              small
                              color="success"
                              @click="viewQr(item)"
                            >
                              <v-icon>mdi-eye</v-icon>
                            </v-btn>
                            <v-btn
                              v-else-if="item.data.data.auto_build === 'error'"
                              icon
                              small
                              color="error"
                              @click="retryQr(item)"
                            >
                              <v-icon>mdi-refresh</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list> -->
                </v-card-text>

                <v-card-text v-else class="text-center">
                  <v-icon size="48" color="grey lighten-1"
                    >mdi-clock-outline</v-icon
                  >
                  <div class="mt-2 text-grey">هیچ موردی در حال ساخت نیست</div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <!-- <v-col class="py-0 px-4" cols="12" md="6">
                <v-switch
                  v-model="mylastQr"
                  label=" افزودن اطلاعات مجموعه، از کیوآرهای قبلی "
                  hide-details
                  dense
                  class="py-0 ma-0"
                ></v-switch>
                <v-autocomplete
                  :disabled="!mylastQr"
                  :readonly="!mylastQr"
                  v-model="selectedQr"
                  :items="QrData"
                  :loading="qrloading"
                  item-text="text"
                  item-value="value"
                  label=" کیوار من"
                  outlined
                  hint="انتخاب کیوآر اختیاری است. در صورت تمایل به استفاده از اطلاعات کاربری کیوآر قبلی"
                  return-object
                  dense
                  :search-input.sync="search"
                  @change="handleSelection"
                >
                  <template v-slot:item="{ item }">
                    <div class="d-flex row gap-3">
                      <v-list-item-content>
                        <v-list-item-title>{{ item.text }}</v-list-item-title>
                      </v-list-item-content>
                    </div>
                  </template>
                  <template> </template>
                  <template v-slot:selection="{ item }">
                    {{ item.name }}
                  </template>
                </v-autocomplete>
              </v-col> -->
        </div>
      </div>
      <progress-modal2
        :show.sync="progressDialog"
        :loading="loadingbulidinglist"
        :closable="!loadingbulidinglist"
        :title="progressTitle"
        :message="progressMessage"
        :show-progress="showProgress"
        ref="progressModal"
        @onShowChange="progressDialog = $event"
      ></progress-modal2>
    </template>
  </help-info-wrapper>
</template>

<script>
import { Bus, RobotAxios, rbAxios, debounce } from "@/main";
import JwtService from "@/core/plugins/TitleRibbon/assets/js/jwt.service";
import svgBase from "@/view/content/svgLoader/svgBase.vue";
import svgLocation from "@/view/content/svgLoader/svgFile/svgLocation";
import axios from "axios";
import QrCodeMake from "../../qrland/qrCodeStyle/qrCodeMake.vue";
import HelpInfo from "../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import HeaderTypeFilter from "../../list/components/headerTypeFilter.vue";
import BusinessType from "./BusinessType.vue";
import qrMaker from "@/view/pages/qrland/components/qrMaker.vue";
import progress_createauto from "./progress_createauto.vue";
import progress_createauto2 from "./progress_createauto2.vue";
import { mapGetters, mapActions } from "vuex";
import createAuto_2 from "./createAuto_2.vue";
import ColorPickerPopup from "./ColorPickerPopup.vue";
import ProgressModal2 from "./ProgressModal2.vue";
import {
  imageToPlainTextAi,
  base64ToBlob,
  saveOnCdnFiles,
} from "@/utilities/ImageGallery";

export default {
  name: "productlabelAuto",

  components: {
    HelpInfo,
    HelpInfoWrapper,
    createAuto_2,
    HeaderTypeFilter,
    BusinessType,
    QrCodeMake,
    ProgressModal2,
    svgBase,
    svgLocation,
    qrMaker,
    progress_createauto,
    progress_createauto2,
    ColorPickerPopup,
  },

  data() {
    return {
      showFileInputAlert: false,
      showAdvancedSettings: false,
      buildingList: [],
      refreshingBuildingList: false,
      organizationName: "",
      latinName: "",
      files: {
        icon: null,
        screenshot: null,
      },
      headerPalette: {
        type: "gradient",
        gradient: {
          type: "linear",
          colors: ["#AA7630", "#EBCB63"],
          direction: "180deg",
        },
      },
      bodyPalette: {
        type: "gradient",
        gradient: {
          type: "linear",
          colors: ["#AA7630", "#EBCB63"],
          direction: "45deg",
        },
      },
      logoLoading: false,
      screenshotLoading: false,
      colorPalette: {
        headerColor: "#AA7630",
        bodyColor: "#EBCB63",
        textColor: "#000000",
      },
      colorTabs: 0,
      headerColorTabs: 0,
      bodyColorTabs: 0,
      headerGradientColor1: "#AA7630",
      headerGradientColor2: "#EBCB63",
      bodyGradientColor1: "#AA7630",
      bodyGradientColor2: "#EBCB63",
      headerGradientPalette: {
        type: "gradient",
        gradient: {
          type: "linear",
          colors: ["#AA7630", "#EBCB63"],
          direction: "45deg",
        },
      },
      bodyGradientPalette: {
        type: "gradient",
        gradient: {
          type: "linear",
          colors: ["#AA7630", "#EBCB63"],
          direction: "45deg",
        },
      },
      loadingbulidinglist: false,
      choiceOImage: false,
      step: 1,
      radioGroup: "mylastQr",
      oldDataQr: false,
      completeProcess: true,
      auto_build: null,
      auto_id: null,
      url_: "",
      hinturl: "https://terminalads.com ",
      url: "",
      flagUrl: false,
      errorurl: "",
      urlRules: [
        (v) => !v || v.length <= 100 || "حداکثر ۱۰۰ کاراکتر مجاز است",
        (v) =>
          !v ||
          this.isURL(v) ||
          " https://terminalads.com :   لینک سایت باید بصورت روبرو وارد شود",
      ],
      Ai_Text: "",
      flag: false,
      mylastQr: false,
      qrId: 0,
      qrloading: false,
      qrselectloading: false,
      selectedQr: null,
      QrData: [],
      countData: 0,
      selectedRows: false,
      tableProps: {
        page: 1,
        length: 100000,
        search: "",
        sort: "desc",
      },

      search: "",
      pagination: {},
      list: [],
      firstPage: false,
      currentPage: 1,
      loadingdata: false,
      perPage: 100000,
      page: null,
      headers: [
        { text: "ردیف", value: "index" },
        { text: "عنوان", value: "title" },
        { text: "لینک", value: "link" },
      ],
      isOldData: false,
      oldData: [],
      file: null,
      info: null,
      createdId: "",
      url: "",
      isLastPage: false,
      indexAt: -1,
      categoryName: "",
      defaultCatName: "",
      img: {
        items: {},
        categories: [],
      },
      x: 0,
      y: 0,
      scale: 1,
      isMarkQrRunning: false,
      qrloading: false,
      qrselectloading: false,
      selectedQr: null,
      selectedQr: null,
      QrData: [],
      countData: 0,
      selectedRows: false,
      tableProps: {
        page: 1,
        length: 100000,
        search: "",
        sort: "desc",
      },
      obj: {},
      search: "",
      valid: false,
      labelName: "",
      name: "",
      progressDialog: false,
      progressTitle: "اطلاع‌رسانی",
      progressMessage: "",
      showProgress: false,
      loading: false,
      theme: "newFactoryLabel",
      qrDesign: {},
      createdDomain: "qrland.in/",
      createdId: null,
      loading: false,
      headColor: "linear-gradient(to right , #D81A1AFF, #2115A7FF)",
      dtUrl: null,
      domainId: 5,
      cardTexts: {
        audiosGallery: [],
        auto_build: null,
        auto_id: null,

        advanceSettings: {
          hasManifestIcons: true,
          viewConfigs: {
            autoCsvDownload: false,
            showCClubOnload: true,
            forcedSubmission: "optional",
          },
          manifest: {
            icon48: "",
            icon144: "",
            screenshotWide: "",
            screenshot600: "",
          },
        },
        customerClub: {
          title: "عضویت در باشگاه مشتریان",
          description: "",
          configs: {
            patternId: 487,
            smsType: "pattern",
            isActive: true,
            message: {
              data1: {
                state: "userInfo",
                text: "name",
              },
              data2: {
                state: "userInfo",
                text: "lastName",
              },
            },
          },
        },
        FeedBack: {
          title: "بازخورد شما",
          description:
            "لطفا با پاسخ گویی به سوالات زیر مارا در خدمات بهتر راهنمایی فرمایید",
          sectionColor: {
            backGround: "linear-gradient(to right , #FFFFFFFF, #FFFFFFFF)",
            text: "#fff",
          },
          type: "text",
          items: [
            {
              question: `چقدر از خدمات ارائه شده راضی بوده اید؟`,
              answer: "",
              value: null,
              description: false,
              forceDesc: false,
            },
            {
              question: `خدمات ارائه شده  چه میزان از نیازهای شما را پوشش داده است؟`,
              answer: "",
              value: null,
              description: false,
              forceDesc: false,
            },
            {
              question:
                "میزان هزینه پرداختی بابت سرویس دریافتی چقدر معقول بوده است؟",
              answer: "",
              value: null,
              description: false,
              forceDesc: false,
            },
            {
              question: "برای  بهبود خدمات نظر خود را با ما درمیان بگذارید.",
              answer: "",
              value: null,
              description: true,
              forceDesc: false,
            },
          ],
        },
        order: [
          { name: "price" },
          { name: "bPrice" },
          { name: "cPrice" },
          { name: "discount" },
          { name: "production" },
          { name: "expiration" },
          { name: "weigth" },
          { name: "size" },
          { name: "model" },
          { name: "series" },
          { name: "country" },
          { name: "producer" },
          { name: "brand" },
          { name: "discriptions" },
        ],
        pallete: {
          headColor: "linear-gradient(to top left , #00BCD4FF, #2F0743FF)",
          bodyColor: "linear-gradient(to top left , #006064FF, #03A9F4FF)",
          textColor: "#000",
          borderColor: "#393939",
        },
        label: {
          name: { text: "نام مجموعه", line: false },
          labelName: { text: "نام محصول", line: false },
          price: { text: 10, line: false },
          bPrice: { text: 10, line: false },
          cPrice: { text: 10, line: false },
          discount: { text: 10, line: false },
          production: { text: "", line: false },
          expiration: { text: "", line: false },
          weigth: { text: "", line: false },
          size: { text: "", line: false },
          model: { text: "", line: false },
          series: { text: "", line: false },
          country: { text: "", line: false },
          producer: { text: 10, line: false },
          brand: { text: 10, line: false },
          discriptions: { text: 10, line: false }, //توضیحات
          img: { text: false, line: false },
          video: { text: false, line: false },
          arm: { text: false, line: false },
        },
        visitName: "لیبل محصول",
        isGradient: false,
        organizationName: "",
        subOrgan: "",
        userName: "",
        workField: "",
        phoneNumber: [
          { number: "", text: "" },
          { number: "", text: "" },
        ],
        extraFields: [{ icon: "", name: "", value: "" }],
        companyNumber: "",
        companyNumberName: "",
        email: "",
        fax: "",
        location: "",
        city: "",
        photo: {
          gallery: [
            {
              name: "",
              images: [],
            },
          ],
          background: "/upload/64b2bb1c4ad38.webp",
          headBackground: "/upload/64b2abe4bab25.webp",
          profile: "/upload/64b2abe4bab25.webp",
          transition: "scale",
          hasWelcome: false,
          hasGif: false,
          hasGame: false,

          previewerQr: {
            previewer: {
              gif: "",
              game: {},
              transition: "scale",
            },
          },
        },
        codePostal: "",
        province: "",
        country: "",
        website: "",
        socialMedia: {},
        aboutUs: "",
        VideoGallery: {
          title: "گالری ویدئو",
          description: "از ویدئوهای مجموع ما دیدن فرمایید.",
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        video_gallery: [
          {
            name: "گالری",
            images: [
              {
                name: "خوش آمدگویی",
                title: "",
                file_link:
                  "https://persian7.asset.aparat.com/aparat-video/1d2d2d8b5fea10b3cbda4fb6e2c45c7653042587-1080p.apt?wmsAuthSign=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6ImFiMjVjNDA3ZmJjMzU4NTRkNzAyYjU4ZTY0ZDc2ZjVhIiwiZXhwIjoxNzUyNTkzNzY1LCJpc3MiOiJTYWJhIElkZWEgR1NJRyJ9.-93y_H0A24w0SV8KdwQMw4w3QTgNmlaGEPn_pqgYCgk",
                description: "",
                link: "",
                id: 15,
              },
            ],
          },
        ],
        center: [51.420296, 35.732379],
        coordinates: [51.420296, 35.732379],
        address: "",
        arm: [],
        apiKey:
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
      },
      qrShow: 1,
      destinationUrl: "",
      qrSvgDataUrl: "",
      file: null,
      info: null,
      createdId: "",
      url: "",
      isLastPage: false,
      indexAt: -1,
      categoryName: "",
      defaultCatName: "",
      img: {
        items: {},
        categories: [],
      },
      loading: false,
      orders: [],
      destItems: [],
      dtUrl: "",

      qrDesign: {
        color: "#000000",
        background: "#FFFFFF",
        pattern: "square",
      },
      domainId: 5,
      createdDomain: "qrland.in/",
      rules: [
        (v) => !!v || "فیلد الزامی است",
        // (v) =>
        //   !v || this.spellChecker(v) || "متن وارد شده باید به زبان فارسی باشد!",
        (v) => (v && v.length >= 3) || "حداقل ۳ کاراکتر باید وارد شود!",

        (v) => (v && v.length <= 300) || "حداکثر ۳۰۰ کاراکتر مجاز است",
      ],
      loading: false,
      result: [],
      translatedText: "",
      business: "",
      tabs: 0,
      type: "",
      count: 1000,
      helpData: [],
      serviceName: "Qrland",
      componentName: "create_Qrlabel",
    };
  },
  provide: {
    provideSingleGallery: true,
  },

  mounted() {
    this.cardTexts.photo.background = this.backgroundUrl;

    this.cardTexts.photo.headBackground = this.headBackgroundUrl;

    this.cardTexts.photo.profile = this.profileUrl;

    this.cardTexts.socialMedia = {
      address: [
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
      ],
      instagram: [
        {
          label: "اینستاگرام",
          text: "نام کاربری خود را وارد نمایید",
          pattern: "",
          prefix: "@",
          url: "terminalads",
          img: "/media/socialIcon/40icon/instagram.svg",
          svg: "svgInstagram",
        },
      ],
      whatsapp: [
        {
          label: "واتساپ",
          text: "",
          pattern: "",
          prefix: "mdi-phone",
          url: "+",
          img: "/media/socialIcon/40icon/whatsapp.svg",
          svg: "svgWhatsapp",
        },
      ],
    };

    Bus.$on("colorPalette", (value) => {
      this.cardTexts.pallete = value;
    });

    Bus.$on("socialMedias", (value) => {
      this.cardTexts.socialMedia = value;
    });

    Bus.$on("uploader", (value) => {
      this.cardTexts.photo = value;
    });

    Bus.$on("gradientType", (value) => {
      this.cardTexts.isGradient = value;
    });
  },
  computed: {
    ...mapGetters("ribbon", ["user"]),
    ...mapGetters("localstorage", ["typeFilter"]),
    backgroundUrl() {
      return this.$cdnUrl + "/upload/64b2bb1c4ad38.webp";
    },
    headBackgroundUrl() {
      return this.$cdnUrl + "/upload/64b2abe4bab25.webp";
    },
    profileUrl() {
      return this.$cdnUrl + "/upload/64b2abe4bab25.webp";
    },
    fullLink() {
      return this.createdDomain?.replace("/", "") + "/" + this.createdId;
    },
    isFormComplete() {
      return (
        this.name &&
        this.name.length >= 3 &&
        this.labelName &&
        this.labelName.length >= 3 &&
        this.file instanceof File &&
        ["image/jpeg", "image/png", "image/jpg"].includes(this.file?.type)
      );
    },
  },
  watch: {
    labelName: {
      deep: true,
      handler(val) {
        if (!!val) {
        }
      },
    },
    "cardTexts.photo.gallery": {
      deep: true,
      immediate: true,
      handler(val) {
        debounce(() => {
          if (!val) this.cardTexts.photo.gallery = [{ name: "", images: [] }];
          if (val?.[0].images?.length > 0) {
            this.cardTexts.label.img = true;
          } else {
            this.cardTexts.label.img = false;
          }
          this.$root.$emit("rerenderSwiper");
        }, 400);
      },
    },
    "cardTexts.video_gallery": {
      deep: true,
      immediate: true,
      handler(val) {
        if (!val) this.cardTexts.video_gallery = [{ name: "", images: [] }];
        const hasVideo = val?.some((item) => item.images.length > 0);
        if (this.cardTexts.label) {
          this.cardTexts.label.video = hasVideo;
        }
      },
    },
    "cardTexts.arm": {
      deep: true,
      handler(val) {
        if (this.cardTexts.label) {
          this.cardTexts.label.arm.text = val.length > 0;
        }
      },
    },
    cardTexts: {
      deep: true,
      immediate: true,
      handler(val) {},
    },
  },

  async created() {
    await this.getQrTypes();
    await this.getdomain();
    await this.clearDefaults();

    await this.fetch();
    // await  this.fetchUserData();
  },
  methods: {
    ...mapActions("localstorage", ["setCreatedQrID", "setQrType"]),
    ...mapActions("local", [
      "updateQrInfo",
      "updateQridentifier",
      "updateQrDomain",
      "updateQrId",
    ]),
    autoSave(options) {
      this.qrDesign = options;
    },
    sendData() {
      return new Promise((resolve, reject) => {
        const formData = new FormData();
        // if (this.files.screenshot !== null) {
        //   formData.append("image", this.files.screenshot);
        // }
        if (!!this.files.icon) formData.append("logo", 1);
        formData.append("image", this.files.screenshot);
        formData.append("type", "qrAutoImage");
        formData.append("title", this.name);
        formData.append("product_name", this.labelName);
        formData.append("processType", "label");
        formData.append("url", this.url_);
        if (this.name.trim() !== "")
          formData.append("organizationName", this.name.trim());

        axios
          .post(this.$aiApi + "/process", formData, {
            headers: this.header(),
          })
          .then((data) => {
            this.auto_id = data.data.id;
            this.auto_build = "process";
            this.cardTexts.auto_id = this.auto_id;
            this.cardTexts.auto_build = this.auto_build;

            resolve(data);
          })
          .catch((error) => {
            this.$modal.error(
              "خطا",
              "شما یک کیوآر در حال ساخت دارید. پس از تکمیل ساخت کیوآر در لیست کیوآر من برای ساخت کیوآر جدید مراجعه کنید.",
            );
            this.completeProcess = false;
            reject(error);
          })
          .finally(() => {});
      });
    },
    getOldData() {
      this.loading = true;

      this.$api
        .get(`/v1/testQr/find/${this.selectedlink}`)
        .then(({ data }) => {
          this.info = data.data;
          this.editedName = data.data.visitName;
          this.$nextTick(() => {
            this.getVisits();
            // this.getStatics()
          });
        })
        .finally(() => (this.loading = false));
    },
    openFileDialog() {
      this.showFileInputAlert = true;
      setTimeout(() => {
        this.showFileInputAlert = false;
      }, 12000);
      this.$refs.fileInputproduct.$refs.input.click();
    },
    async getBoundingBox(imageUrl) {
      const image = new Image();
      image.crossOrigin = "anonymous";
      image.src = imageUrl;

      await new Promise((resolve, reject) => {
        image.onload = resolve;
        image.onerror = reject;
      });

      const canvas = document.createElement("canvas");
      canvas.width = image.width;
      canvas.height = image.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(image, 0, 0);

      const imageData = ctx.getImageData(0, 0, image.width, image.height).data;
      let minX = image.width,
        minY = image.height,
        maxX = 0,
        maxY = 0;

      for (let y = 0; y < image.height; y++) {
        for (let x = 0; x < image.width; x++) {
          const alpha = imageData[(y * image.width + x) * 4 + 3];
          if (alpha > 0) {
            minX = Math.min(minX, x);
            minY = Math.min(minY, y);
            maxX = Math.max(maxX, x);
            maxY = Math.max(maxY, y);
          }
        }
      }
      const width_obj = maxX - minX + 1;
      const height_obj = maxY - minY + 1;
      const scale_x = 1920 / (width_obj + 10);
      const scale_y = 1080 / (height_obj + 10);
      this.scale = Math.min(scale_x, scale_y);

      const new_width = width_obj * this.scale;
      const new_height = height_obj * this.scale;

      this.x = Math.floor(-minX * this.scale + (1920 - new_width) / 2);
      this.y = Math.floor(-minY * this.scale + (1080 - new_height) / 2);
    },
    async saveOnFile(input) {
      const formData = new FormData();
      if (input.type) {
        formData.append("file", input);
        formData.append("format", input.type.replace("image/", ""));
      } else {
        const fileExtension = input.split(".").pop().toLowerCase();
        formData.append("file", input);
        formData.append("format", fileExtension);
      }

      try {
        const response = await axios.post(
          this.$aiApi + "/image/user/upload",
          formData,
          {
            headers: this.header() || {},
          },
        );

        return response.data;
      } catch (error) {
        this.$toast?.error("آپلود تصویر با مشکل رو برو شد");
        throw error;
      }
    },
    clearLocalStorge(identifier) {
      const storageKey = `qrUserData_${identifier}`;
      localStorage.removeItem(storageKey);
    },
    async selectedHandlerUrl() {
      if (!this.url_) {
        this.errorurl = "لطفا آدرس سایت را وارد کنید";
        return;
      }
      this.errorurl = "";
      try {
        const { data } = await RobotAxios.post(
          `/api/enamad/manual?url=${this.url_}&qr_id=11&response=1`,
          {
            token: localStorage.getItem("id_token"),
          },
        );
        if (!!data && !!data.data) {
          const qrData = data.data;
          // map data to cardTexts
          // this.cardTexts.userName = qrData.data.userName || "";
          // this.cardTexts.workField = qrData.data.workField || "";

          this.cardTexts.organizationName =
            this.name.trim() !== "" ? this.name.trim() : qrData.title || "";

          this.cardTexts.phoneNumber =
            !!qrData?.phone && !!qrData?.title
              ? [{ number: qrData.phone, text: qrData.title }]
              : [{ number: "", text: "" }];
          this.cardTexts.socialMedia =
            qrData.socialMedia || this.cardTexts.socialMedia || {};

          this.cardTexts.address =
            qrData.address || this.cardTexts.address || "";

          this.cardTexts.city = qrData.city || this.cardTexts.city || "";

          this.cardTexts.province =
            qrData.province || this.cardTexts.province || "";

          this.cardTexts.country =
            qrData.country || this.cardTexts.country || "";

          this.cardTexts.website = qrData.site || this.cardTexts.website || "";
          this.cardTexts.aboutUs =
            this.aboutUs ||
            qrData.aboutUs ||
            qrData.description ||
            this.cardTexts.aboutUs ||
            "";

          this.cardTexts.blog = qrData.blog || this.cardTexts.blog || [];

          this.cardTexts.email = qrData.email || this.cardTexts.email || "";

          this.cardTexts.fax = qrData.fax || this.cardTexts.fax || "";

          this.cardTexts.location = qrData.location || this.cardTexts.location;

          this.cardTexts.companyNumber =
            qrData.companyNumber ||
            qrData.phone ||
            this.cardTexts.companyNumber;

          this.cardTexts.codePostal =
            qrData.codePostal || this.cardTexts.codePostal;

          this.cardTexts.coordinates =
            qrData.coordinates || this.cardTexts.coordinates;

          this.cardTexts.copyright =
            qrData.copyright || this.cardTexts.copyright;

          this.cardTexts.advanceSettings = !!this.files.screenshot
            ? this.cardTexts.advanceSettings
            : qrData.advanceSettings;

          this.cardtexts.logo = !!this.files.icon
            ? this.cardTexts.logo
            : qrData.logo || "";

          this.$toast.success("داده‌های QR با موفقیت بارگذاری شد.");
        }
      } catch (error) {
        //console.error("Error fetching user data:", error);
      } finally {
        this.qrselectloading = false;
      }
    },
    handleSelection() {
      const item = this.selectedQr;
      if (item && item.value) {
        this.selectedQr = item;
        this.fetchUserData(item.value);
      } else {
        console.log("کیواری انتخاب نشده");
      }
    },
    header() {
      return {
        Authorization: JwtService.getToken()
          ? `Bearer ${JwtService.getToken()}`
          : null,
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*",
        "Content-Type": "application/json",
      };
    },
    cleanlabelName(labelname) {
      const words = labelname
        .split(" ")
        .filter((word, index, arr) => arr.indexOf(word) === index);
      return words.join(" ").trim();
    },
    filterEnglishOnly(text) {
      return text.replace(/[^a-zA-Z0-9-]/g, "");
    },

    clearDefaults() {
      this.$root.$emit("clearDefaultData");
      this.cardTexts.visitName = "";
      this.cardTexts.isGradient = false;
      this.cardTexts.organizationName = "";
      this.cardTexts.subOrgan = "";
      this.cardTexts.userName = "";
      this.cardTexts.workField = "";
      this.cardTexts.phoneNumber = [{ number: "" }];
      this.cardTexts.extraFields = [
        {
          icon: "",
          name: "",
          value: "",
        },
      ];
      this.cardTexts.label = {
        name: { text: "", line: false },
        labelName: { text: "", line: false },
        price: { text: 0, line: false },
        bPrice: { text: 0, line: false },
        cPrice: { text: 0, line: false },
        discount: { text: null, line: false },
        production: { text: null, line: false },
        expiration: { text: "", line: false },
        weigth: { text: "", line: false },
        size: { text: "", line: false },
        model: { text: "", line: false },
        series: { text: "", line: false },
        country: { text: "", line: false },
        producer: { text: null, line: false },
        brand: { text: null, line: false },
        discriptions: { text: null, line: false }, //توضیحات
        img: { text: false, line: false },
        video: { text: false, line: false },
      };

      this.cardTexts.Features = {
        show: "accordion",
        details: [
          {
            name: "",
            showIt: false,
            value: [],
          },
        ],
      };
      this.cardTexts.companyNumber = "";
      this.cardTexts.email = "";
      this.cardTexts.fax = "";
      this.cardTexts.location = "";
      this.cardTexts.city = "";
      this.cardTexts.singleProduct = {
        name: "",
        description: "",
        price: 0,
        discount: "0",
        payLink: "",
        btnSetting: {
          title: "",
          icon: undefined,
          background: "linear-gradient(to top left , #D81A1AFF, #2115A7FF)",
          color: "white",
        },
        extra: [
          {
            label: "",
            value: "",
            icon: "",
            name: "",
            link: "",
          },
        ],
        image: "",
        color: undefined,
        arm: [],
      };
      this.cardTexts.photo = {
        gallery: null,
        headBackground: "",
        profile: "",
        transition: "scale",
        hasWelcome: false,
        hasGif: false,
        hasGame: false,

        previewerQr: {
          previewer: {
            gif: "",
            game: {},
            transition: "scale",
          },
        },
      };
      this.cardTexts.codePostal = "";
      this.cardTexts.province = "";
      this.cardTexts.country = "";
      this.cardTexts.website = "";
      this.cardTexts.socialMedia = {};
      this.cardTexts.aboutUs = "";
      this.cardTexts.video_single = {
        name: "",
        videos: [],
      };
      this.cardTexts.center = [51.420296, 35.732379];
      this.cardTexts.coordinates = null;
      this.cardTexts.address = "";
      this.cardTexts.apiKey =
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg";
    },
    clearFile() {
      this.file = null;
      this.$toast.info("فایل پاک شد.");
    },
    getdomain() {
      this.domainId = 5;
    },
    countData2() {
      let p = {};

      // set filters
      p.sort = "desc";

      p.search = "";

      // end filters
      this.$api
        .get("/v1/testQr/user/count", {
          params: p,
        })
        .then((data) => {
          this.countData = data.count;
        })
        .finally(() => {});
    },
    async fetch(params = this.tableProps) {
      if (this.loadingdata) return;
      this.loadingdata = true;

      try {
        await this.countData2();
        params.length = this.countData;

        const { data } = await this.$api.get("/v1/testQr/user", {
          params: params,
        });

        this.pagination = data.data;
        this.list = data.data.data;
        // this.QrData = this.list
        //   .filter((x) => x.domain !== null && x.extra_short?.identifier)
        //   .map((x) => ({
        //     value: `${x.domain.name}${x.extra_short.identifier}`,
        //     text: `${x.data.data.visitName} - ${x.domain.name}${x.extra_short.identifier}`,
        //     name: x.data.data.visitName, // اطمینان از وجود name برای نمایش
        //   }));
        this.$set(this, "QrData", [
          ...this.list
            .filter((x) => x.domain !== null && x.identifier)
            .map((x) => ({
              value: `${x.domain.name}${x.identifier}`,
              text: `${x.data.data.visitName || "بدون نام"} - ${x.domain.name}${
                x.identifier
              }`,
              name: x.data.data.visitName || "بدون نام",
            })),
        ]);
      } catch (error) {
      } finally {
        this.loadingdata = false;
      }
    },
    async markQr() {
      //   if (this.isMarkQrRunning) return;
      this.isMarkQrRunning = true;
      this.loading = true;
      try {
        if (this.radioGroup === "flagUrl" && !!this.url_) {
          await this.selectedHandlerUrl();
        }
        if (this.name.trim() !== "")
          this.cardTexts.organizationName = this.name.trim();

        const obj = {
          type: "labelProduct",
          qrType: "dynamic",
          title: this.cardTexts.visitName,
          domain_id: this.domainId,
          data: JSON.stringify({
            theme: this.theme,
            data: this.cardTexts,
          }),
          qr: JSON.stringify(this.qrDesign),
          identifier: this.filterEnglishOnly(this.dtUrl),
        };

        // 7. ارسال درخواست ذخیره
        const { data } = await this.$api.post("/v1/testQr/store", obj);
        // if (
        //   !response.data ||
        //   !response.data.identifier ||
        //   !response.data.qrId
        // ) {
        //   // throw new Error("Invalid response from store API");
        // }
        this.createdId = await data.data.identifier;
        this.updateQridentifier(data.data.identifier);
        this.createdDomain = "qrland.in/";
        this.setCreatedQrID(data.data.id);
        this.updateQrId(data.data.id);
        this.info = await data?.data;
        this.qrDesign = { ...this.info.qr };
        await this.$nextTick();
        if (this.$refs.qrCanvas && !!this.info.link) {
          await this.$refs.qrCanvas.appendCanvas(this.info.link);
        }
        await this.$nextTick();

        await new Promise((resolve, reject) => {
          const checkSvg = () => {
            if (this.qrSvgDataUrl) {
              resolve();
            } else {
              setTimeout(checkSvg, 10000);
            }
          };
          setTimeout(() => reject(new Error("SVG generation timeout")), 10000);
          checkSvg();
        });

        await this.checkVideo();
        if (!data || this.info === null) {
        } else if (!!data && !!data.data && !!data.data.qrId) {
          this.qrId = this.info.qrId;
          const data2 = new FormData();
          data2.append("type", "labelProduct");
          data2.append("image", this.qrSvgDataUrl);
          data2.append("qrType", "dynamic");
          data2.append("domain", this.createdDomain);
          data2.append("identifier", this.createdId || this.info.identifier);
          data2.append("_method", "PUT");
          data2.append("qr", JSON.stringify(this.qrDesign));
          data2.append("qr_id", this.qrId);
          data2.append(
            "data",
            JSON.stringify({
              theme: this.theme,
              data: this.cardTexts,
            }),
          );

          await this.$api
            .post("/v1/testQr/update", data2, {
              headers: {
                "Content-Type": "application/from-data",
              },
            })
            .then(({ data }) => {
              this.info = data.data;
              this.$toast.success("کیوآر لیبل محصول شما با موفقیت  ساخته شد .");

              // this.goto("qr/list");
            })
            .catch((err) => {})
            .finally(() => {});
        }
        this.$toast.success("لیبل محصول شما با موفقیت ساخته شد.");
      } catch ({ response }) {
        if (response?.data?.errors) {
          if (
            response.data.errors.identifier[0] ===
              "آدرس کیوآر قبلا انتخاب شده است." &&
            response?.status === 422
          ) {
            this.step = 1;
            const parts = this.filterEnglishOnly(this.dtUrl).split("-");
            const lastPart = parts[parts.length - 1];

            if (!isNaN(lastPart)) {
              parts[parts.length - 1] = this.generateUID(); //splice(DateTime.now(), 6, 4); // Number(lastPart) + 1;

              this.dtUrl = parts.join("-");
            } else {
              this.dtUrl = parts.join("-");
              this.dtUrl = `${this.filterEnglishOnly(
                this.dtUrl,
              )}-${this.generateUID()}`;
              await this.markQr();
            }
          } else {
            Object.keys(response.data.errors).forEach((item) => {
              this.$toast.error(response.data.errors[item][0], {
                timeout: 3000,
              });
            });
          }
        } else {
          // this.$toast.error("ساخت کیوآر با خطا روبرو شد لطفا مجدد تلاش کنید!");
          // return;
        }
      } finally {
        this.loading = false;
        this.isMarkQrRunning = false;
      }
    },
    selectQr(data) {
      this.type = data;
    },

    async onFileChange(file) {
      if (file === null) {
        this.file = null;
        return;
      }
      if (
        file instanceof File &&
        ["image/jpeg", "image/png"].includes(file.type)
      ) {
        this.file = file;
        await this.getInfo();
      } else {
        console.error("نوع فایل مشکل دارد:", file);
        this.$toast.error("لطفاً فقط فایل‌های JPG یا PNG انتخاب کنید.");
        this.file = null;
      }
    },
    async getInfo() {
      if (!this.file) {
        this.$modal.error("لطفاً یک تصویر انتخاب کنید.");
        return;
      }
      try {
        const fileUrl = await saveOnCdnFiles(
          this.file,
          `upload_${Date.now()}`,
          "uploads",
        );
        this.cardTexts.label.img = true;
        this.$toast.success("تصویر با موفقیت آپلود شد: ");
      } catch (error) {
        this.$toast.error("خطا در دریافت تصویر!");
        console.error(error);
      }
    },
    clealabelName(labelName) {
      const words = labelName
        .split(" ")
        .filter((word, index, arr) => arr.indexOf(word) === index);
      return words.join(" ").trim();
    },
    async generatorTextAi() {
      if (this.loading) return;
      if (!this.$refs.form.validate()) {
        this.$toast.error("اطلاعات را درست وارد کنید.");
        return;
      }

      this.loading = true;
      this.progressTitle = "اطلاع‌رسانی";
      this.progressMessage = `سامانه در حال ساخت کیوآر کد شماست.\nزمان تقریبی ساخت 1 الی 3 دقیقه خواهد بود.`;
      this.showProgress = true;
      this.progressDialog = true;

      try {
        await this.sendData(); // send data for back
        // if (!this.completeProcess) {
        //   this.$toast.error(
        //     "شما یک کیوآر در حال ساخت دارید. پس از تکمیل ساخت کیوآر در لیست کیوآر من برای ساخت کیوآر جدید مراجعه کنید."
        //   );
        //   this.loading = false;
        //   return;
        // }
        if (this.completeProcess === true) {
          await this.translatePrompt(this.labelName, "fa", "en");
          const englishlabelName = this.translatedText;
          const cleanedlabelName = this.cleanlabelName(englishlabelName);
          this.cardTexts.visitName = this.labelName;
          this.dtUrl =
            this.latinName.toLowerCase().replace(/\s+/g, "-") ||
            englishlabelName.toLowerCase().replace(/\s+/g, "-");

          // const descriptionPrompt = this.file
          //   ? `Analyze the provided image and generate a professional description for a product label for a ${cleanedlabelName}. Include a short title (1-2 words), a concise description (1-2 sentences) inspired by the image, and 3-5 key features or benefits of the product. Use a professional and engaging tone, suitable for a product label. Return the content as structured HTML with <h1> for the title, <p> for the description, and <ul><li> for each feature.`
          //   : `Generate a professional description for a product label for a ${cleanedlabelName}. Include a short title (1-2 words), a concise description (1-2 sentences) of the product, and 3-5 key features or benefits of the product. Use a professional and engaging tone, suitable for a product label. Return the content as structured HTML with <h1> for the title, <p> for the description, and <ul><li> for each feature.`;
          // const { data } = await imageToPlainTextAi({
          //   file: this.file || null,
          //   description: descriptionPrompt,
          // });
          //  const aiText = data.data?.translated || "";//check??
          // const aiText = data.data?.html || "";
          // await this.processAiText(aiText, englishlabelName);
          try {
            await this.fetchDigikalaData(this.labelName);
          } catch (err) {
            console.log("no set data of dig");
          }
          // await this.genenterimageAi(englishlabelName);
          //   await this.prepareLogo();
          await this.markQr();
          await this.qrUpdate();

          this.$toast.success("عملیات با موفقیت تکمیل شد.");
          this.refreshBuildingList(); //fetch data for list of building
          // this.goto("qr/list");
          this.loading = false;
          this.$refs.progressModal.complete();
        }
      } catch (error) {
        this.$toast.error("خطا در دریافت اطلاعات!");
        console.error(error);
        this.$refs.progressModal.complete();
        //   this.$refs.progressModal.close();
      } finally {
        this.loading = false;
        this.progressDialog = false;
      }
    },
    async prepareLogo() {
      if (this.file) {
        try {
          const logoFile = await this.removeBackground();
          this.cardTexts.photo.profile = logoFile.data.link; //await this.saveOnFile(logoFile);
        } catch (error) {
          console.error("خطا در آماده‌سازی لوگو:", error);
          this.$toast.error("خطا در پردازش لوگو!");
        }
      }
    },
    async processAiText(aiHtml, englishlabelName, englishHtml = null) {
      // Parse HTML
      const parser = new DOMParser();
      const doc = parser.parseFromString(aiHtml || "<div></div>", "text/html");

      // Extract title (first heading or fallback)
      const titleElement = doc.querySelector("h1, h2, h3") || {
        textContent: englishlabelName,
      };
      const englishDoc = englishHtml
        ? parser.parseFromString(englishHtml, "text/html")
        : null;

      let title = titleElement.textContent.trim(); //.slice(0, 20); // Limit to 20 chars
      if (!title) title = englishlabelName;
      const persianTitle = title || "لیبل محصول";

      // Extract description (first paragraph, div, or fallback)
      const descriptionElement = doc.querySelector("p, div") || {
        textContent: "",
      };
      let description = descriptionElement.textContent.trim(); //.slice(0, 100); // Limit to 100 chars
      const persianDescription = description
        ? description
        : "توضیحات ارائه خدمات حرفه‌ای برای لیبل محصول شما.";

      // Extract features (list items or fallback)
      const listItems = Array.from(
        doc.querySelectorAll("li, p > span, div > span"),
      );
      const items = listItems
        //.slice(0, 5)
        .map((li) => {
          // Limit to 5 features
          const strong = li.querySelector("strong, b");
          const englishLi = englishDoc?.querySelectorAll(
            "li, p > span, div > span",
          )[index];
          const englishStrong = englishLi?.querySelector("strong, b");

          return {
            title:
              strong?.textContent.trim() ||
              li.textContent.trim().split(":")[0] ||
              "",
            description: strong
              ? this.cleanHtmlText(
                  li.textContent.replace(strong.textContent, ""),
                )
              : this.cleanHtmlText(
                  li.textContent.split(":").slice(1).join(":"),
                ) || li.textContent.trim(),
            original:
              englishStrong?.textContent.trim() ||
              englishLi?.textContent.trim().split(":")[0] ||
              li.textContent.trim(),
          };
        })
        .filter((item) => item.title || item.description); // Remove empty items

      // Translate items to Persian
      const persianItems = await Promise.all(
        items.map(async (item) => ({
          title: item?.title || "ویژگی",
          description: item.description || "توضیحات",
          original: item.title || item.description,
        })),
      );
      if (persianItems.length === 0) {
        try {
          const fallbackTitle = "ویژگی";
          const fallbackDescription = "توضیحات";
          persianItems.push({
            title: fallbackTitle,
            description: fallbackDescription,
            original: "Feature",
          });
        } catch (error) {
          console.error("Fallback feature translation error:", error.message);
          persianItems.push({
            title: "ویژگی",
            description: "توضیحات",
            original: "Feature",
          });
        }
      }
      const icons = await this.assignIcons(
        items.map((item) => item.original || item.title || item.description),
      );

      // Update cardTexts
      this.cardTexts.visitName = this.labelName;
      this.cardTexts.label.name = this.name;
      this.cardTexts.label.labelName = this.labelName;
      this.cardTexts.aboutUs = persianDescription;
      this.cardTexts.extraFields = persianItems.map((item, index) => ({
        icon: icons[index] || "mdi-information",
        name: item.title,
        value: item.description,
      }));

      // Set dtUrl for QR code
      this.dtUrl =
        this.latinName.toLowerCase().replace(/\s+/g, "-") ||
        englishBusiness.toLowerCase().replace(/\s+/g, "-");
    },
    async assignIcons(texts) {
      const iconMap = {
        "scan|scanning|barcode|qr|read|reader|code|qrcode": "mdi-qrcode-scan",
        "precision|accuracy|target|exact|correct|pinpoint|sharp": "mdi-target",
        "durable|durability|resilient|strong|robust|tough|sturdy|hardy":
          "mdi-shield-check",
        "response|speed|fast|quick|rapid|swift|efficient|prompt":
          "mdi-clock-fast",
        "user-friendly|ease|simple|usable|intuitive|easy|accessible|straightforward":
          "mdi-account-check",
        "security|secure|safe|safety|protected|trustworthy|reliable|encrypted":
          "mdi-lock",
        "quality|high-quality|premium|superior|excellent|top-notch|exceptional":
          "mdi-star",
        "innovation|innovative|modern|advanced|cutting-edge|new|forward-thinking":
          "mdi-lightbulb-on",
        "connectivity|connection|network|wireless|bluetooth|internet|linked":
          "mdi-wifi",
        "compatibility|compatible|versatile|flexible|adaptable|universal":
          "mdi-cellphone-link",
        "portable|portability|mobile|lightweight|compact|travel-friendly":
          "mdi-briefcase",
        "battery|power|energy|long-lasting|charge|rechargeable|endurance":
          "mdi-battery",
        "design|style|stylish|elegant|aesthetic|beautiful|sleek|modern":
          "mdi-palette",
        "dimensions|size|compact|large|small|measurement|proportion":
          "mdi-ruler",
        "weight|light|heavy|lightweight|featherweight": "mdi-weight",
        "color|colour|vivid|bright|shade|hue|vibrant": "mdi-format-color-fill",
        "eco-friendly|environment|green|sustainable|recyclable|biodegradable":
          "mdi-leaf",
        "support|customer-service|assistance|help|care|aftercare|service":
          "mdi-headset",
        "versatile|multifunctional|all-in-one|multi-purpose|multi-use":
          "mdi-all-inclusive",
        "technology|tech|digital|smart|intelligent|automated": "mdi-chip",
        "global|worldwide|international|universal|cross-border": "mdi-earth",
        "affordable|cost-effective|budget-friendly|cheap|value|economical":
          "mdi-currency-usd",
        "performance|performant|powerful|strong|effective|high-performance":
          "mdi-gauge",
        "privacy|private|confidential|discreet|secure-data": "mdi-eye-off",
        "installation|setup|easy-to-install|assembly|deploy": "mdi-tools",
        "warranty|guarantee|assurance|certified|backed": "mdi-certificate",
        "accessibility|available|reach|convenient|handy": "mdi-map-marker",
        "stability|stable|dependable|consistent|steady": "mdi-anchor",
        "collaboration|teamwork|partnership|cooperation|synergy":
          "mdi-account-group",
        "information|informative|details|data|insights|knowledge":
          "mdi-information",
        "customization|customizable|personalized|tailored|bespoke": "mdi-cog",
        "scalability|scalable|expandable|grow|growth": "mdi-arrow-expand",
        "reliability|reliable|trusty|dependable|consistent": "mdi-check-circle",
        "automation|automated|self-operating|smart-operation": "mdi-robot",
        "comfort|comfortable|ergonomic|cozy|user-comfort": "mdi-sofa",
        "efficiency|efficient|optimized|streamlined|productive": "mdi-rocket",
        "weather-resistant|waterproof|dustproof|rugged":
          "mdi-weather-partly-cloudy",
        "real-time|live|instant|immediate": "mdi-update",
        "integration|integrated|seamless|connect|unified": "mdi-puzzle",
        "health|wellness|medical|care|hygiene": "mdi-hospital",
        "food|cuisine|menu|dining|culinary": "mdi-food",
        "education|learning|training|knowledge|study": "mdi-school",
        "entertainment|fun|media|leisure|enjoyment": "mdi-television",
      };
      return texts.map((text) => {
        const lowerText = text.toLowerCase();
        for (const [pattern, icon] of Object.entries(iconMap)) {
          const regex = new RegExp(`\\b(${pattern})\\b`, "i");
          if (regex.test(lowerText)) {
            return icon;
          }
        }
        return "mdi-information";
      });
    },
    async urlToFile(imageUrl, fileName = "image.jpg") {
      try {
        const response = await fetch(imageUrl);
        // if (!response.ok) throw new Error("خطا در دانلود تصویر");

        const blob = await response.blob();
        const file = new File([blob], fileName, { type: blob.type });
        return file;
      } catch (error) {
        console.error("خطا در تبدیل URL به فایل:", error);
        throw error;
      }
    },

    async removeBackground() {
      try {
        // const photoproduct = await this.urlToFile(imageUrl, "photoproduct.png");
        const formData = new FormData();
        formData.append("image", this.file);
        const { data } = await axios.post(
          this.$aiApi + "/image/remove/back/v2",
          formData,
          {
            headers: {
              ...this.header(),
            },
          },
        );
        if (data && data.image) {
          return new File(
            [await (await fetch(data.image)).blob()],
            "logo.png",
            {
              type: "image/png",
            },
          );
        }

        return data;
      } catch (error) {
        console.error("خطا در ارسال به API:", error);
        throw error;
      }
    },
    async fetchUserData(identifier) {
      try {
        this.qrselectloading = true;
        const storageKey = `qrUserData_${identifier}`;
        const cachedData = localStorage.getItem(storageKey);
        if (cachedData) {
          const parsedData = JSON.parse(cachedData);
          this.applyUserData(parsedData.data);
          this.qrselectloading = false;
          return;
        }

        const { data } = await this.$api.get(`/v1/testQr/find/${identifier}`);

        if (data && data.data && data.data.data) {
          const qrData = data.data.data;
          this.applyUserData(qrData);
          localStorage.setItem(storageKey, JSON.stringify({ data: qrData }));
          this.$toast.success("داده‌های QR با موفقیت از سرور بارگذاری شد.");
        } else {
          this.$toast.error("داده‌های QR یافت نشد.");
        }
      } catch (error) {
        // console.error("Error fetching user data:", error);
        this.$toast.error("خطا در دریافت اطلاعات کاربر");
      } finally {
        this.qrselectloading = false;
      }
    },
    applyUserData(qrData) {
      // map data to cardTexts
      this.cardTexts.organizationName =
        this.name.trim() || qrData.data.organizationName || "";
      this.cardTexts.phoneNumber = qrData.data.phoneNumber || [
        { number: "", text: "" },
      ];
      this.cardTexts.socialMedia =
        qrData.data.socialMedia || this.cardTexts.socialMedia || {};
      this.cardTexts.address =
        qrData.data.address || this.cardTexts.address || "";
      this.cardTexts.city = qrData.data.city || this.cardTexts.city || "";
      this.cardTexts.province =
        qrData.data.province || this.cardTexts.province || "";
      this.cardTexts.country =
        qrData.data.country || this.cardTexts.country || "";
      this.cardTexts.website =
        qrData.data.website || this.cardTexts.website || "";
      this.cardTexts.aboutUs =
        qrData.data.aboutUs || this.cardTexts.aboutUs || "";
      this.cardTexts.blog = qrData.data.blog || this.cardTexts.blog || [];
      this.cardTexts.email = qrData.data.email || this.cardTexts.email || "";
      this.cardTexts.fax = qrData.data.fax || this.cardTexts.fax || "";
      this.cardTexts.location = qrData.data.location || this.cardTexts.location;
      this.cardTexts.organizationName =
        this.name.trim() ||
        qrData.data.organizationName ||
        this.cardTexts.organizationName;
      this.cardTexts.companyNumber =
        qrData.data.companyNumber || this.cardTexts.companyNumber;
      this.cardTexts.codePostal =
        qrData.data.codePostal || this.cardTexts.codePostal;
      this.cardTexts.coordinates =
        qrData.data.coordinates || this.cardTexts.coordinates;
      this.cardTexts.copyright =
        qrData.data.copyright || this.cardTexts.copyright;
      this.cardTexts.advanceSettings =
        qrData.data.advanceSettings || this.cardTexts.advanceSettings;
    },
    async fetchDigikalaData(labelName) {
      try {
        const { data: searchData } = await axios.get(
          `${this.$qrApi}/template?length=1&page=1&search=${encodeURIComponent(
            labelName,
          )}`,
        );

        const product = searchData.data.data[0];
        if (product) {
          const productInfo = product.data;

          // Map product information to cardTexts.label
          this.cardTexts.label.labelName = this.labelName;
          this.cardTexts.label.name =
            productInfo.brand || this.name || "فروشنده ناشناس";
          this.cardTexts.label.price = productInfo.price || 0;
          this.cardTexts.label.cPrice = productInfo.price || 0; // Fallback for RRP price
          this.cardTexts.label.bPrice = productInfo.price || 0; // Fallback for before discount
          this.cardTexts.label.discount = productInfo.discount || 0;
          this.cardTexts.label.producer = productInfo.brand || "";
          this.cardTexts.label.brand = productInfo.brand || "";
          this.cardTexts.label.series = productInfo.series || "";
          this.cardTexts.label.model =
            productInfo.model || productInfo.title || "";
          this.cardTexts.label.discriptions = productInfo.description || "";
          this.cardTexts.label.country = productInfo.country || "";

          // Extract specifications
          const specs = productInfo.details || [];

          // Map specifications to new extraFields
          const newSpecItems = specs.map((attr) => ({
            name: attr.label,
            value: attr.value,
          }));

          // Assign icons for new specifications
          const icons = await this.assignIcons(
            newSpecItems.map((item) => item.name),
          );

          // Merge new specifications with existing extraFields (avoid duplicates)
          const existingExtraFields = this.cardTexts.extraFields || [];
          const existingNames = new Set(
            existingExtraFields.map((item) => item.name),
          );

          const mergedExtraFields = [
            ...existingExtraFields,
            ...newSpecItems
              .filter((item) => !existingNames.has(item.name)) // Avoid duplicates
              .map((item, index) => ({
                icon: icons[index] || "mdi-information",
                name: item.name,
                value: item.value,
              })),
          ];

          // Update cardTexts.extraFields
          this.cardTexts.extraFields = mergedExtraFields;

          // Map images from Digikala
          const listImages =
            productInfo.gallery[0]?.images?.map((item, index) => ({
              url: item.url,
              title: "",
              name: "",
              id: index + 1,
              description: "",
              link: "",
            })) || [];

          // Merge Digikala images with existing gallery images
          this.cardTexts.photo.gallery = this.cardTexts.photo.gallery || [
            { name: "گالری تصاویر", images: [] },
          ];
          this.cardTexts.photo.gallery[0].images = [
            ...this.cardTexts.photo.gallery[0].images,
            ...listImages,
          ];
          // this.cardTexts.photo.gallery[0].images.push(
          //   listImages
          // )
          // Update img flag
          this.cardTexts.label.img =
            this.cardTexts.photo.gallery[0].images.length > 0;

          // Set aboutUs
          this.cardTexts.aboutUs =
            productInfo.description || this.cardTexts.aboutUs;

          // Set organizationName
          this.cardTexts.organizationName =
            this.name.trim() ||
            this.cardTexts.organizationName ||
            productInfo.brand ||
            "";

          this.$toast.success("اطلاعات محصول با موفقیت دریافت شد");
        }
      } catch (error) {
        // console.error("Error fetching Digikala data:", error);
        //this.$toast.error("خطا در دریافت اطلاعات محصول");
      }
    },
    // async fetchDigikalaData(labelName) {
    //   try {
    //     const { data: searchData } = await axios.get(
    //       `https://qr-api.terminalads.com/api/template?length=1&page=1&search=${encodeURIComponent(
    //         labelName
    //       )}`
    //     );
    //     const product = searchData.data.data[0];
    //     if (!product) {
    //       throw new Error("Product not found");
    //     }
    //     const idproductdigi = product.id;
    //     const productInfo = product.data;

    //     // Map to cardTexts.label
    //     this.cardTexts.label.labelName = productInfo.title;
    //     this.cardTexts.label.name = productInfo.brand || "فروشنده ناشناس";
    //     this.cardTexts.label.price = productInfo.price || 0;
    //     this.cardTexts.label.cPrice = productInfo.price || 0; // RRP price not available, using price as fallback
    //     this.cardTexts.label.bPrice = productInfo.price || 0; // Before discount not available, using price
    //     this.cardTexts.label.discount = productInfo.discount || 0;
    //     this.cardTexts.label.producer = productInfo.brand || "";
    //     this.cardTexts.label.brand = productInfo.brand || "";
    //     this.cardTexts.label.series = productInfo.model || "";
    //     this.cardTexts.label.discriptions = productInfo.description || "";
    //     this.cardTexts.label.country = productInfo.country;
    //     this.cardTexts.label.series = productInfo.series;
    //     this.cardTexts.label.model = productInfo.model;

    //     // Extract specifications from details
    //     const specs = productInfo.details || [];
    //     this.cardTexts.label.weigth =
    //       specs.find((attr) => attr.label === "وزن")?.value || "";
    //     this.cardTexts.label.size =
    //       specs.find((attr) => attr.label === "ابعاد")?.value || "";
    //     this.cardTexts.label.model =
    //       specs.find((attr) => attr.label === "مدل")?.value ||
    //       productInfo.title;

    //     // Populate extraFields with specifications
    //     const specItems = specs.slice(0, 5).map((attr) => ({
    //       name: attr.label,
    //       value: attr.value,
    //     }));
    //     const icons = await this.assignIcons(
    //       specItems.map((item) => item.name)
    //     );
    //     this.cardTexts.extraFields = specItems.map((item, index) => ({
    //       icon: icons[index] || "mdi-information",
    //       name: item.name,
    //       value: item.value,
    //     }));

    //     // Map images
    //     this.cardTexts.photo.gallery = this.cardTexts.photo.gallery || [
    //       {
    //         name: "گالری تصاویر",
    //         images: [],
    //       },
    //     ];
    //     const listImages =
    //       productInfo.gallery[0]?.images
    //         .map((item) => item.url)
    //         .filter((url) => url) || [];
    //     this.cardTexts.photo.gallery[0].images = [...listImages];

    //     this.cardTexts.label.img =
    //       this.cardTexts.photo.gallery[0].images.length > 0;

    //     // Set aboutUs
    //     this.cardTexts.aboutUs =
    //       productInfo.description || this.cardTexts.aboutUs;

    //     // Set organizationName
    //     this.cardTexts.organizationName =
    //       this.cardTexts.organizationName || productInfo.brand || "";

    //     this.$toast.success("اطلاعات محصول با موفقیت دریافت شد");
    //   } catch (error) {
    //     console.error("خطا در دریافت اطلاعات:", error);
    //     this.$toast.error("خطا در دریافت اطلاعات محصول");
    //   }
    // },
    // async fetchDigikalaData(labelName) {
    //   try {
    //     const { data: searchData } = await axios.get(
    //       `https://qr-api.terminalads.com/api/template?length=10&page=1&search=${encodeURIComponent(
    //         labelName
    //       )}`
    //     );
    //     const product = searchData.products.find(
    //       (x) => x.title_fa === labelName || x.title_fa.includes(labelName)
    //     );
    //     if (!product) {
    //       throw new Error("Product not found");
    //     }
    //     const idproductdigi = product.id;
    //     const { data: productData } = await axios.get(
    //       `https://api.digikala.com/v2/product/${idproductdigi}/`
    //     );
    //     const productInfo = productData.data.product;

    //     // Map to cardTexts.label
    //     this.cardTexts.label.labelName = productInfo.title_fa;
    //     this.cardTexts.label.name = this.name || productInfo.seller.title;
    //     this.cardTexts.label.price =
    //       productInfo.variants[0].price.selling_price || 0;
    //     this.cardTexts.label.cPrice =
    //       productInfo.variants[0].price.rrp_price || 0;
    //     this.cardTexts.label.bPrice =
    //       productInfo.variants[0].insurance.before_discount || 0;
    //     this.cardTexts.label.discount =
    //       productInfo.variants[0].price.discount_percent || 0;
    //     this.cardTexts.label.brand = productInfo.brand.title_fa;
    //     this.cardTexts.label.producer = productInfo.seller.title;
    //     this.cardTexts.label.series = productInfo.brand.code;
    //     this.cardTexts.label.discriptions =
    //       productInfo.review.description ||
    //       productInfo.expert_reviews.description ||
    //       "";

    //     // Extract specifications
    //     const specs = productInfo.specifications[0]?.attributes || [];
    //     this.cardTexts.label.weigth =
    //       specs.find((attr) => attr.title === "وزن")?.values[0] || "";
    //     this.cardTexts.label.size =
    //       specs.find((attr) => attr.title === "ابعاد")?.values[0] || "";
    //     this.cardTexts.label.model =
    //       specs.find((attr) => attr.title === "مدل")?.values[0] ||
    //       productInfo.variants[0].id.toString();
    //     // Populate extraFields with specifications
    //     const specItems = specs.slice(0, 5).map((attr) => ({
    //       name: attr.title,
    //       value: attr.values[0],
    //     }));
    //     const icons = await this.assignIcons(
    //       specItems.map((item) => item.name)
    //     );
    //     this.cardTexts.extraFields = specItems.map((item, index) => ({
    //       icon: icons[index] || "mdi-information",
    //       name: item.name,
    //       value: item.value,
    //     }));
    //     this.cardTexts.photo.gallery = this.cardTexts.photo.gallery || [
    //       {
    //         name: "گالری تصاویر",
    //         images: [],
    //       },
    //     ];
    //     // Map images
    //     const mainImage = productInfo.images.main?.url?.[0] || null;
    //     const listImages = Array.isArray(productInfo.images.list)
    //       ? productInfo.images.list
    //           .map((item) => item.url?.[0])
    //           .filter((url) => url)
    //       : [];
    //     this.cardTexts.photo.gallery[0].images = mainImage
    //       ? [mainImage, ...listImages]
    //       : listImages;
    //     this.cardTexts.label.img =
    //       this.cardTexts.photo.gallery[0].images.length > 0;

    //     // Set aboutUs
    //     this.cardTexts.aboutUs =
    //       productInfo.review.description ||
    //       productInfo.expert_reviews.description ||
    //       this.cardTexts.aboutUs;

    //     // Set visitName
    //     this.cardTexts.visitName = productInfo.title_fa;

    //     // Optionally set organizationName
    //     this.cardTexts.organizationName =
    //       this.cardTexts.organizationName || productInfo.seller.title;

    //     this.$toast.success("اطلاعات محصول از دیجی‌کالا با موفقیت دریافت شد");
    //   } catch (error) {
    //     console.error("خطا در دریافت اطلاعات از دیجی‌کالا:", error);
    //     this.$toast.error("خطا در دریافت اطلاعات محصول از دیجی‌کالا");
    //   }
    // },
    // async genenterimageAi(englishlabelName) {
    //   try {
    //     const cleanlabelName = (labelName) => {
    //       const words = labelName
    //         .split(" ")
    //         .filter((word, index, arr) => arr.indexOf(word) === index);
    //       return words.join(" ").trim();
    //     };
    //     const cleanedlabelName = cleanlabelName(englishlabelName);

    //     const photoproductPrompt = `A high-resolution, text-free photo of a ${cleanedlabelName}, realistic and professional style, clean and modern design, vibrant colors, suitable for product branding, no text or letters`;
    //     const bannerPrompt = `A wide, text-free promotional banner depicting a ${cleanedlabelName}, vibrant and dynamic composition, professional and modern style, high-resolution, no text or letters, suitable for website headers`;
    //     const mainImagePrompt = `A high-resolution, text-free background image designed as a backdrop for a ${cleanedlabelName}, abstract or subtle texture, professional and modern style, warm lighting, no text or letters, ideal for website backgrounds to showcase a product`;

    //     const imageRequests = [
    //       { width: 512, height: 512, text: photoproductPrompt, amount: 1 }, // لوگو
    //       { width: 1920, height: 1088, text: bannerPrompt, amount: 1 }, // Banner 1
    //       { width: 1920, height: 1088, text: bannerPrompt, amount: 1 }, // Banner 2
    //       { width: 1920, height: 1088, text: bannerPrompt, amount: 1 }, // Banner 3
    //       { width: 1920, height: 1088, text: mainImagePrompt, amount: 1 }, // main image
    //       { width: 1920, height: 1088, text: mainImagePrompt, amount: 1 }, // photoproductback
    //     ];
    //     let imagelogo = null;
    //     if (this.file) {
    //       try {
    //         imagelogo = await this.removeBackground();
    //         imagelogo = await this.saveOnFile(imagelogo);
    //       } catch (error) {
    //         this.$toast.error("خطا در پردازش لوگو!");
    //       }
    //     }
    //     const maxRetries = 4;
    //     const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    //     if (!this.file || !(this.file instanceof File)) {
    //       this.$toast.error("لطفاً یک تصویر انتخاب کنید.");
    //       return;
    //     }

    //     const generateImage = async (
    //       { text, width, height, amount },
    //       retries = maxRetries
    //     ) => {
    //       try {
    //         const formData = new FormData();
    //         formData.append("image", this.file);
    //         formData.append("height", height);
    //         formData.append("width", width);
    //         formData.append("theme", "Surprise me");
    //         formData.append("angle", 0);

    //         const { data } = await axios.post(
    //           "https://ai-api.terminalads.com/api/image/generate-background",
    //           formData,
    //           { headers: this.header() }
    //         );

    //         if (!data.data || !data.data.link) {
    //           throw new Error(`No image link returned for prompt: ${text}`);
    //         }

    //         return data.data.link;
    //       } catch (error) {
    //         if (retries > 0) {
    //           console.warn(
    //             `Retrying for prompt: ${text}. Attempts left: ${retries}`
    //           );
    //           await delay(500);
    //           return generateImage(
    //             { text, width, height, amount },
    //             retries - 1
    //           );
    //         }
    //         throw error;
    //       }
    //     };

    //     const images = [];
    //     for (const request of imageRequests) {
    //       const image = await generateImage(request);
    //       images.push(image);
    //     }

    //     // Save images and merge with existing gallery
    //     const savedImages = await this.saveImages(images);

    //     const [photoproduct, banner1, banner2, banner3, mainImage, background] =
    //       savedImages;

    //     this.cardTexts.photo.profile =
    //       imagelogo || this.cardTexts.photo.profile;
    //     this.cardTexts.photo.headBackground =
    //       mainImage || this.cardTexts.photo.headBackground;
    //     this.cardTexts.photo.background =
    //       background || this.cardTexts.photo.background;

    //     // Merge new images with existing gallery
    //     this.cardTexts.photo.gallery = this.cardTexts.photo.gallery || [
    //       { name: "گالری تصاویر", images: [] },
    //     ];
    //     this.cardTexts.photo.gallery[0].images = [
    //       ...this.cardTexts.photo.gallery[0].images,
    //       ...(banner1 ? [banner1] : []),
    //       ...(banner2 ? [banner2] : []),
    //       ...(banner3 ? [banner3] : []),
    //       ...(photoproduct ? [photoproduct] : []),
    //     ];

    //     this.cardTexts.label.img =
    //       this.cardTexts.photo.gallery[0].images.length > 0;
    //     this.$root.$emit("rerenderSwiper");
    //   } catch (error) {
    //     this.$toast.error("خطا در تولید تصاویر!");
    //     console.error(error);
    //   }
    // },
    // async saveImages(imageUrls) {

    //   const [photoproduct, banner1, banner2, banner3, mainImage, background] =
    //     imageUrls;

    //   // Helper function to fetch image and convert to blob
    //   async function urlToBlob(url) {
    //     if (!url) return null;
    //     try {
    //       const response = await fetch(url);
    //       if (!response.ok)
    //         throw new Error(`Failed to fetch image from ${url}`);
    //       return await response.blob();
    //     } catch (error) {
    //       console.error(`Error fetching image from ${url}:`, error);
    //       return null;
    //     }
    //   }

    //   try {
    //     const savedUrls = [];
    //     // Save photoproduct
    //     if (photoproduct) {
    //       const photoproductBlob = await urlToBlob(photoproduct);

    //       const photoproductUrl = photoproductBlob
    //         ? await this.saveOnFile(photoproductBlob)
    //         : null;

    //       savedUrls.push(photoproductUrl.data);

    //     } else {
    //       savedUrls.push(null);
    //     }

    //     // Save banners
    //     const bannerUrls = await Promise.all(
    //       [banner1, banner2, banner3].map(async (banner, index) => {
    //         if (banner) {
    //           const bannerBlob = await urlToBlob(banner);
    //           return bannerBlob ? await this.saveOnFile(bannerBlob) : null;
    //         }
    //         return null;
    //       })
    //     );
    //     bannerUrls.map((x) => savedUrls.push(x.data));

    //     // Save main image
    //     if (mainImage) {
    //       const mainBlob = await urlToBlob(mainImage);
    //       const mainUrl = mainBlob ? await this.saveOnFile(mainBlob) : null;
    //       savedUrls.push(mainUrl.data);
    //     } else {
    //       savedUrls.push(null);
    //     }

    //     // Save background
    //     if (background) {
    //       const backgroundBlob = await urlToBlob(background);
    //       const backgroundUrl = backgroundBlob
    //         ? await this.saveOnFile(backgroundBlob)
    //         : null;
    //       savedUrls.push(backgroundUrl.data);
    //     } else {
    //       savedUrls.push(null);
    //     }

    //     return savedUrls;
    //   } catch (error) {

    //     this.$toast.error("خطا در ذخیره تصاویر!");
    //     throw error;
    //   }
    // },

    // async getImage(text, width, height) {
    //   try {

    //     const { data } = await axios.post(
    //       "https://ai-api.terminalads.com/api/image/generate-background",
    //       {
    //         // x:,
    //         // y:,
    //         angle: 0,
    //         // scale_x:1,
    //         // scale_y:1,
    //         height: height,
    //         width: width,
    //         theme: "Surprise me",
    //         image: this.file,
    //       },
    //       { headers: this.header() }
    //     );

    //     if (!!data.data.link) {
    //       this.result.push({
    //         image: data.data.link,
    //         prompt: text,
    //         checked: false,
    //       });
    //       this.indexAt = 0;
    //     }
    //   } catch (response) {
    //     console.error(response);
    //   } finally {
    //     this.loading = false;
    //   }
    // },
    async genenterimageAi(englishlabelName) {
      try {
        const customLogoUploaded = await this.handleCustomLogo();
        const cleanlabelName = (labelName) => {
          const words = labelName
            .split(" ")
            .filter((word, index, arr) => arr.indexOf(word) === index);
          return words.join(" ").trim();
        };
        const cleanedlabelName = cleanlabelName(englishlabelName);

        // const photoproductPrompt = `A high-resolution, text-free photo of a ${cleanedlabelName}, realistic and professional style, clean and modern design, vibrant colors, suitable for product branding, no text or letters`;
        const bannerPrompt = `A wide, text-free promotional banner depicting a ${cleanedlabelName}, vibrant and dynamic composition, professional and modern style, high-resolution, no text or letters, suitable for website headers`;
        // const mainImagePrompt = `A high-resolution, text-free background image designed as a backdrop for a ${cleanedlabelName}, abstract or subtle texture, professional and modern style, warm lighting, no text or letters, ideal for website backgrounds to showcase a product`;

        const imageRequests = [
          { width: 1920, height: 1080, text: bannerPrompt, amount: 1 }, // Banner 1
          { width: 1920, height: 1080, text: bannerPrompt, amount: 1 }, // Banner 2
          { width: 1920, height: 1080, text: bannerPrompt, amount: 1 }, // Banner 3
          { width: 1920, height: 1080, text: bannerPrompt, amount: 1 }, // Banner 4
        ];

        if (!this.file || !(this.file instanceof File)) {
          this.$toast.error("لطفاً یک تصویر انتخاب کنید.");
          return;
        }

        let imagelogo = null;
        if (this.file) {
          try {
            imagelogo = await this.removeBackground();
            imagelogo = imagelogo.data.link; //await this.saveOnFile(imagelogo);
            await this.getBoundingBox(imagelogo);
          } catch (error) {
            console.error("خطا در حذف پس‌زمینه لوگو:", error);
            this.$toast.error("خطا در پردازش لوگو!");
          }
        }

        const images = [];
        for (const request of imageRequests) {
          const image = await this.generateImage(request);
          images.push(image);
        }

        let savedImages = await this.saveImages(images);

        savedImages = Array.isArray(savedImages) ? savedImages : [];
        while (savedImages.length < 6) {
          savedImages.push(null);
        }

        const [
          // photoproduct,
          banner1,
          banner2,
          banner3,
          banner4,
          // mainImage,
          // background,
        ] = savedImages;

        this.cardTexts.photo.profile =
          imagelogo ||
          this.cardTexts.photo.profile ||
          this.$cdnUrl + "/upload/64b2abe4bab25.webp";
        this.cardTexts.photo.background =
          imagelogo ||
          background ||
          this.cardTexts.photo.background ||
          this.$cdnUrl + "/upload/64b2bb1c4ad38.webp";
        this.cardTexts.photo.headBackground =
          imagelogo ||
          mainImage ||
          this.cardTexts.photo.headBackground ||
          this.$cdnUrl + "/upload/64b2abe4bab25.webp";

        // ادغام تصاویر جدید با گالری موجود
        this.cardTexts.photo.gallery = this.cardTexts.photo.gallery || [
          { name: "گالری تصاویر", images: [] },
        ];
        this.cardTexts.photo.gallery[0].images = [
          ...(this.cardTexts.photo.gallery[0].images || []),
          // {
          //   url: mainImage,
          //   title: "",
          //   name: "",
          //   id: 100011,
          //   description: "",
          //   link: ""
          // },
          // {
          //   url: background,
          //   title: "",
          //   name: "",
          //   id: 100012,
          //   description: "",
          //   link: ""
          // },
          {
            url: banner1,
            title: "",
            name: "banner1",
            id: 10001,
            description: "",
            link: "",
          },
          {
            url: banner2,
            title: "",
            name: "banner2",
            id: 10002,
            description: "",
            link: "",
          },
          {
            url: banner3,
            title: "",
            name: "banner3",
            id: 10003,
            description: "",
            link: "",
          },
          {
            url: banner4,
            title: "",
            name: "banner4",
            id: 10004,
            description: "",
            link: "",
          },
        ];
        this.cardTexts.label.img =
          this.cardTexts.photo.gallery[0].images.length > 0;
        this.$root.$emit("rerenderSwiper");
      } catch (error) {
        this.$toast.error("خطا در تولید تصاویر!");
        // console.error(error);
      }
    },
    async saveImages(imageUrls) {
      async function urlToBlob(url) {
        if (!url) return null;
        try {
          const response = await fetch(url);
          if (!response.ok)
            //   throw new Error(`Failed to fetch image from ${url}`);
            return await response.blob();
        } catch (error) {
          console.error(`Error fetching image from ${url}:`, error);
          return null;
        }
      }

      try {
        const savedUrls = [];

        // پردازش هر URL تصویر
        for (const url of imageUrls) {
          const blob = await urlToBlob(url);
          const savedUrl = blob ? await this.saveOnFile(blob) : null;
          savedUrls.push(savedUrl ? savedUrl.data : null);
        }

        return savedUrls;
      } catch (error) {
        // console.error("Error in saveImages:", error);
        this.$toast.error("خطا در ذخیره تصاویر!");
        return []; // بازگشت آرایه خالی برای جلوگیری از undefined
      }
    },
    async generateImage({ text, width, height, amount }, retries = 4) {
      try {
        const formData = new FormData();
        formData.append("image", this.file);
        formData.append("height", height);
        formData.append("width", width);
        formData.append("theme", "Surprise me");
        formData.append("angle", 0);
        formData.append("scale_x", this.scale);
        formData.append("scale_y", this.scale);
        formData.append("x", this.x);
        formData.append("y", this.y);

        const { data } = await axios.post(
          this.$aiApi + "/image/generate-background",
          formData,
          { headers: this.header() },
        );

        if (!data.data || !data.data.link) {
          //  throw new Error(`No image link returned for prompt: ${text}`);
        }

        return data.data.link;
      } catch (error) {
        if (retries > 0) {
          console.warn(
            `Retrying for prompt: ${text}. Attempts left: ${retries}`,
          );
          await new Promise((resolve) => setTimeout(resolve, 500));
          return this.generateImage(
            { text, width, height, amount },
            retries - 1,
          );
        }
        console.error(`Failed to generate image for prompt: ${text}`);
        return null; // بازگشت null در صورت شکست تمام تلاش‌ها
      }
    },
    async getImages(i) {
      this.loading = true;

      let params = {
        paginate: 1,
        page: 1,
        category: undefined,
        dir: "desc",
      };
      const res = await rbAxios
        .get(`${this.$robotApi}/files`, { params })
        .then(({ data }) => {
          let lastImg = this.img?.items?.data || [];
          let temp = data.data;
          temp.items.data = lastImg.concat(temp.items.data);
          this.img = temp;

          if (!!this.defaultCatName) this.categoryName = this.defaultCatName;

          this.isLastPage = !data.data.items.next_page_url;
          this.page++;
        })
        .catch(({ response }) => {
          console.log("error in get images: ", response);
        })
        .finally(() => (this.loading = false));
    },
    saveImage() {
      // Example Base64 string and mimeType
      const base64String = this.result.at(this.indexAt).image;
      const mimeType = "application/octet-stream"; // Adjust the MIME type as needed

      // Convert Base64 to Blob
      const fileBlob = base64ToBlob(base64String, mimeType);
      saveOnCdnFiles(
        fileBlob,
        this.result.at(this.indexAt).prompt.replace(/ /g, "_"),
        this.categoryName,
      )
        .then((response) => {})
        .catch((error) => {
          this.$toast.error("خطا در آپلود تصویر.");
        })
        .finally(() => {});
    },
    stripHtmlTags(html) {
      const doc = new DOMParser().parseFromString(html, "text/html");
      return doc.body.textContent || "";
    },

    async translatePrompt(
      text,
      from = "fa",
      to = "en",
      maxRetries = 3,
      interval = 10000,
    ) {
      if (!text || text.replace(/\n/g, " ").trim() === "") {
        throw new Error("Input text is empty or invalid");
      }

      let retries = 0;

      while (retries < maxRetries) {
        try {
          const response = await axios.post(
            this.$aiApi + "/image/translate",
            {
              text: text.replace(/\n/g, " "),
              from,
              to,
            },
            { headers: this.header() },
          );
          const translatedText = Array.isArray(response?.data.data)
            ? response?.data?.data?.[0]?.["destination-text"]
            : response?.data?.data?.["destination-text"];

          if (!!translatedText) {
            this.translatedText = translatedText;
            return this.translatedText;
          }
          await new Promise((resolve) => setTimeout(resolve, interval));
          retries++;
        } catch (error) {
          console.error("Translation attempt failed:", error.message);
          if (retries >= maxRetries - 1) {
            throw new Error("Translation failed after maximum retries");
          }
          await new Promise((resolve) => setTimeout(resolve, interval));
          retries++;
        }
      }
      // throw new Error("Translation failed after maximum retries");
    },
    async processImageRequests(imageRequests) {
      const results = [];
      for (const { text, width, height, amount } of imageRequests) {
        let attempts = 0;
        const maxRetries = 4;

        while (attempts < maxRetries) {
          try {
            const { data } = await axios.post(
              this.$aiApi + "/image/generate-background",
              {
                x: this.x,
                y: this.y,
                angle: 0,
                scale_x: this.scale,
                scale_y: this.scale,
                height: height,
                width: width,
                theme: "Surprise me",
                image: this.file,
              },
              { headers: this.header() },
            );

            if (!data.data || !data.data[0]?.link) {
              // throw new Error(`هیچ لینک عکس برای این متن نیست${text}`);
            }
            if (Array.isArray(data.data)) {
              results.push(...data.data.map((item) => item.link));
            }
            await delay(2000);
            break;
          } catch (error) {
            attempts++;
            if (attempts >= maxRetries) {
              console.error(`شکست در تولید ${text} برای ${maxRetries} تلاش`);
            } else {
              console.warn(`سعی مجدد ${attempts} برای ${text}`);
              await delay(3000);
            }
          }
        }
        await delay(200);
      }

      return results;
    },
    spellChecker(input) {
      const reg = /^[\u0600-\u06FF\u06F0-\u06F9\s,\-]*$/;
      return input && Array.from(input.trim()).every((char) => reg.test(char));
    },
    async qrUpdate() {
      this.loading = true;
      try {
        this.qrDesign = { ...this.info.qr };
        await this.$nextTick();
        if (this.$refs.qrCanvas && !!this.info.link) {
          await this.$refs.qrCanvas.appendCanvas(this.info.link);
        }
        await this.$nextTick();
        setTimeout(() => {}, 100000);
        await new Promise((resolve, reject) => {
          const checkSvg = () => {
            if (this.qrSvgDataUrl) {
              resolve();
            } else {
              setTimeout(checkSvg, 8000);
            }
          };
          setTimeout(() => reject(new Error("SVG generation timeout")), 8000);
          checkSvg();
        });
        this.checkVideo();
        const data = new FormData();
        data.append("type", "labelProduct");
        data.append("image", this.qrSvgDataUrl);
        data.append("qrType", "dynamic");
        data.append("domain", this.createdDomain);
        data.append("identifier", this.createdId);
        data.append("qr", JSON.stringify(this.qrDesign));
        data.append("qr_id", this.info.qrId);

        data.append("_method", "PUT");
        data.append(
          "data",
          JSON.stringify({
            theme: this.theme,
            data: this.cardTexts,
          }),
        );
        const { data: response } = await this.$api.post(
          "/v1/testQr/update",
          data,
          {
            headers: { "Content-Type": "multipart/form-data" },
          },
        );
        this.info = response.data;
        this.$toast.success("لیبل محصول شما باموفقیت تکمیل شد.");

        //  this.$refs.progressModal.complete();
        // this.goto("qr/list");
      } catch (error) {
        this.$toast.error("خطا در به‌روزرسانی کیوآر!");
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    refreshBuildingList() {
      this.refreshingBuildingList = true;
      this.fetchBuildingList()
        .then(() => {
          this.refreshingBuildingList = false;
          this.$toast.success("لیست ساخت‌ها با موفقیت به‌روزرسانی شد.");
        })
        .catch((error) => {
          this.refreshingBuildingList = false;
          this.$toast.error("خطا در به‌روزرسانی لیست ساخت‌ها:", error.message);
        });
    },
    getStatusColor(status) {
      switch (status) {
        case "process":
          return "primary";
        case "success":
          return "success";
        case "failed":
          return "error";
        default:
          return "info";
      }
    },
    getStatusIcon(status) {
      switch (status) {
        case "process":
          return "mdi-progress-clock";
        case "success":
          return "mdi-check-circle";
        case "failed":
          return "mdi-close-circle";
        default:
          return "mdi-help-circle";
      }
    },
    getStatusText(status) {
      switch (status) {
        case "process":
          return "در حال ساخت";
        case "success":
          return "ساخت شده";
        case "failed":
          return "ساخت ناموفق";
        default:
          return "در حال ساخت";
      }
    },
    async checkAndFixDuplicateUrl() {
      let baseUrl = this.dtUrl;
      let counter = 1;
      let isDuplicate = true;

      while (isDuplicate && counter <= 9999) {
        try {
          // Check if URL exists
          const response = await this.$api.get(
            `/v1/testQr/check-identifier/${this.dtUrl}`,
          );
          if (response.data.exists) {
            // URL exists, add 4-digit number
            // this.dtUrl = `${baseUrl}-${counter.toString().padStart(4, "0")}`;
            this.dtUrl = `${baseUrl}-${this.generateUID()}`;

            counter++;
          } else {
            isDuplicate = false;
          }
        } catch (error) {
          // If error, assume URL doesn't exist
          isDuplicate = false;
        }
      }
    },
    copyToClipboard(text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.$toast.success("کد رنگ کپی شد");
        })
        .catch(() => {
          this.$toast.error("خطا در کپی کردن");
        });
    },
    updateColorPalette(newPalette) {
      this.colorPalette = newPalette;
      this.cardTexts.pallete.headColor = newPalette.headerColor;
      this.cardTexts.pallete.bodyColor = newPalette.bodyColor;
      this.cardTexts.pallete.textColor = newPalette.textColor;
    },
    //new - Building List Methods
    async fetchBuildingList() {
      try {
        let type = "labelProduct";
        const response = await this.$api.get(
          `/v1/testQr/user/auto?type=${type}`,
        );

        this.buildingList = response.data.data.data || [];
      } catch (error) {
        console.error("Error fetching building list:", error);
      }
    },
    async refreshBuildingList() {
      this.refreshingBuildingList = true;
      try {
        await this.fetchBuildingList();
      } finally {
        this.refreshingBuildingList = false;
      }
    },
    getStatusColor(status) {
      switch (status) {
        case "process":
          // change color
          return "orange";
        case "success":
          return "green";
        case "error":
          return "red";
        default:
          return "grey";
      }
    },
    getStatusIcon(status) {
      switch (status) {
        case "process":
          return "mdi-clock-outline";
        case "success":
          return "mdi-check-circle";
        case "error":
          return "mdi-alert-circle";
        default:
          return "mdi-help-circle";
      }
    },
    getStatusText(status) {
      switch (status) {
        case "process":
          return "در حال ساخت";
        case "success":
          return "تکمیل شده";
        case "error":
          return "خطا در ساخت";
        default:
          return "نامشخص";
      }
    },
    getProgressColor(progress) {
      if (progress < 30) return "red";
      if (progress < 70) return "orange";
      return "green";
    },
    // viewQr(item) {
    //   // Open QR in new tab
    //   window.open(item.url, "_blank");
    // },
    // retryQr(item) {
    //   // Retry failed QR
    //   this.$toast.info("تلاش مجدد برای ساخت کیوآر کد...");
    //   // Add retry logic here
    // },
    //new - Advanced Settings Methods
    updateHeaderColor(color) {
      if (color) {
        this.headerColor = color;
        this.cardTexts.pallete.headColor = color;
      }
    },
    updateBodyColor(color) {
      if (color) {
        this.bodyColor = color;
        this.cardTexts.pallete.bodyColor = color;
      }
    },
    updateHeaderGradientColor1(color) {
      if (color) {
        this.headerGradientColor1 = color;
        this.cardTexts.pallete.headColor = `linear-gradient(45deg, ${color}, ${this.headerGradientColor2})`;
      }
    },
    updateHeaderGradientColor2(color) {
      if (color) {
        this.headerGradientColor2 = color;
        this.cardTexts.pallete.headColor = `linear-gradient(45deg, ${this.headerGradientColor1}, ${color})`;
      }
    },
    updateBodyGradientColor1(color) {
      if (color) {
        this.bodyGradientColor1 = color;
        this.cardTexts.pallete.bodyColor = `linear-gradient(45deg, ${color}, ${this.bodyGradientColor2})`;
      }
    },
    updateBodyGradientColor2(color) {
      if (color) {
        this.bodyGradientColor2 = color;
        this.cardTexts.pallete.bodyColor = `linear-gradient(45deg, ${this.bodyGradientColor1}, ${color})`;
      }
    },
    updateHeaderGradientPalette() {
      if (this.headerGradientPalette.type === "color") {
        this.headerGradientColor1 = this.headerGradientPalette.color;
        this.cardTexts.pallete.headColor = this.headerGradientPalette.color;
      } else {
        this.headerGradientColor1 =
          this.headerGradientPalette.gradient.colors[0];
        this.headerGradientColor2 =
          this.headerGradientPalette.gradient.colors[1];
        this.cardTexts.pallete.headColor = `linear-gradient(${this.headerGradientPalette.gradient.direction}, ${this.headerGradientPalette.gradient.colors[0]}, ${this.headerGradientPalette.gradient.colors[1]})`;
      }
    },
    updateBodyGradientPalette() {
      if (this.bodyGradientPalette.type === "color") {
        this.bodyGradientColor1 = this.bodyGradientPalette.color;
        this.cardTexts.pallete.bodyColor = this.bodyGradientPalette.color;
      } else {
        this.bodyGradientColor1 = this.bodyGradientPalette.gradient.colors[0];
        this.bodyGradientColor2 = this.bodyGradientPalette.gradient.colors[1];
        this.cardTexts.pallete.bodyColor = `linear-gradient(${this.bodyGradientPalette.gradient.direction}, ${this.bodyGradientPalette.gradient.colors[0]}, ${this.bodyGradientPalette.gradient.colors[1]})`;
      }
    },
    updateColorPalette(newPalette) {
      this.colorPalette = newPalette;
      this.cardTexts.pallete.headColor = newPalette.headerColor;
      this.cardTexts.pallete.bodyColor = newPalette.bodyColor;
      this.cardTexts.pallete.textColor = newPalette.textColor;
    },
    readerRead(file, slot = "logo") {
      if (file) {
        const reader = new FileReader();
        const _this = this;

        reader.onload = function (e) {
          const img = new Image();
          img.onload = function () {
            switch (slot) {
              case "logo":
                _this.inputChange(img);
                break;
              case "screenshot":
                _this.screenInputChange(img);
                break;
            }
          };
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    inputChange(img) {
      const canvas144 = document.getElementById("canvas144");
      this.drawImageOnCanvasCover(canvas144, img, 144, 144);

      const canvas48 = document.getElementById("canvas48");
      this.drawImageOnCanvasCover(canvas48, img, 48, 48);
      this.uploadCanvasImage(canvas48, "48px_image.png", "icon48", "logo");
      this.uploadCanvasImage(canvas144, "144px_image.png", "icon144", "logo");
    },
    screenInputChange(img) {
      const canvasWide = document.getElementById("screenshotWide");
      this.drawImageOnCanvasCover(canvasWide, img, 1280, 720);

      const canvas600 = document.getElementById("screenshot600");
      this.drawImageOnCanvasCover(canvas600, img, 600, 400);
      this.cardTexts.photo.main;

      this.uploadCanvasImage(
        canvasWide,
        "wide_image.png",
        "screenshotWide",
        "screenshot",
      );
      this.uploadCanvasImage(
        canvas600,
        "600_image.png",
        "screenshot600",
        "screenshot",
      );
    },
    checkVideo() {
      let search = this.labelName;
      //https://qr-api.terminalads.com/api/user/aparat?default=1&page=1&length=100&search=""
      this.$api
        .get(`/user/aparat?default=1&page=1&length=10000&search=${search}`)
        .then(({ data }) => {
          if (data?.data?.length > 0) {
            //for title
            // let url = data.data.file_link.split()
            this.cardTexts.video_gallery = [
              {
                name: "گالری ویدئو",
                images: [
                  {
                    name: data.data[0].title,
                    title: data.data[0].title,
                    url: data.data[0].file_link,
                    file_link: data.data[0].file_link,
                    description: "",
                    link: data.data[0].file_link,
                    id: data.data[0].id,
                  },
                ],
              },
            ];
          } else {
            search = this.name;
            this.$api
              .get(
                `/user/aparat?default=1&page=1&length=10000&search=${search}`,
              )
              .then(({ data }) => {
                if (data?.data?.length > 0) {
                  //for text
                  this.cardTexts.video_gallery = [
                    {
                      name: "گالری ویدئو",
                      images: [
                        {
                          name: data.data[0].title,
                          title: data.data[0].title,
                          url: data.data[0].file_link,
                          file_link: data.data[0].file_link,
                          description: "",
                          link: data.data[0].file_link,
                          id: data.data[0].id,
                        },
                      ],
                    },
                  ];
                } else {
                  //welcome
                  this.cardTexts.video_gallery = [
                    {
                      name: "گالری ویدئو",
                      images: [
                        {
                          name: "خوش آمدگویی",
                          title: "",
                          url: "https://www.aparat.com/video/video/embed/videohash/a89rkt7/vt/frame",
                          file_link: "https://www.aparat.com/v/a89rkt7",
                          description: "",
                          link: "https://www.aparat.com/v/a89rkt7",
                          id: 15,
                        },
                      ],
                    },
                  ];
                }
              })
              .finally(() => {});
          }
        })
        .finally(() => {});
    },
    drawImageOnCanvasCover(canvas, img, width, height) {
      const ctx = canvas.getContext("2d");
      canvas.width = width;
      canvas.height = height;

      const scale = Math.max(width / img.width, height / img.height);
      const scaledWidth = img.width * scale;
      const scaledHeight = img.height * scale;

      const x = (width - scaledWidth) / 2;
      const y = (height - scaledHeight) / 2;

      ctx.drawImage(img, x, y, scaledWidth, scaledHeight);
    },
    uploadCanvasImage(canvas, filename, field, type) {
      if (type === "logo") {
        this.logoLoading = true;
      } else if (type === "screenshot") {
        this.screenshotLoading = true;
      }

      const imageDataUrl = canvas.toDataURL("image/png");
      const base64String = imageDataUrl.replace("data:image/png;base64,", "");
      const mimeType = "application/octet-stream";
      const fileBlob = base64ToBlob(base64String, mimeType);
      saveOnCdnFiles(
        fileBlob,
        filename.replace(/ /g, "_"),
        "تصاویر وب اپلیکیشن",
      )
        .then(({ data }) => {
          this.$toast.success("تصویر با موفقیت آپلود شد");
          this.cardTexts.advanceSettings.manifest[field] = data.data.link;
          if (type === "logo" && field === "icon144")
            this.cardTexts.photo.profile = data.data.link;
          if (type === "screenshot" && field === "screenshotWide") {
            this.cardTexts.photo.headBackground = data.data.link;
          }
        })
        .catch((err) => {
          // this.$toast.warn(
          //   "آپلود تصویر با مشکل روبرو شد. لطفا مجدد بارگذاری کنید"
          // );
          if (type === "logo") {
            this.logoLoading = false;
          }
          if (type === "screenshot") {
            this.screenshotLoading = false;
          }
        })
        .finally(() => {
          if (type === "logo") {
            this.logoLoading = false;
          }
          if (type === "screenshot") {
            this.screenshotLoading = false;
          }
          this.logoLoading = false;
          this.screenshotLoading = false;
        });
    },
  },
};
</script>

<style scoped></style>
